export default {
    zh: {
        // 页面标题和描述
        pageTitle: 'Runway Gen-4 视频生成器 - 专业视频创作工具',
        pageDescription:
            '体验 Runway Gen-4 视频生成器，支持文本转视频、图像转视频、智能视频编辑等功能。创建专业AI视频，在WeryAI平台免费试用。',
        pageKeywords:
            'Runway Gen-4, Runway AI, AI视频生成器, text to video, image to video, video editing, free AI video, 微鲤AI, video production',

        // 生成器部分
        generatorTitle: 'Runway Gen-4 视频生成器',
        generatorDescription:
            'Runway Gen-4 和 Gen-4 Turbo 是 Runway 最新推出的 <span >AI 视频生成模型</span>。基于之前的 Gen-3 Alpha Turbo 模型，这个新版本显著提升了<span >提示词的遵循度和动作的真实感</span>，以及跨场景的<span >角色、风格和物体的一致性</span>。现在就来 <span >微鲤AI 视频生成器体验 Runway Gen-4 Turbo</span>！',

        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Runway Gen-4 的主要功能',
        coreFeaturesSubtitle:
            '探索 Runway Gen-4 AI 视频生成器的核心功能，开启革命性的 AI 视频创作之旅',

        // 逼真的视频生成
        realisticVideoTitle: '逼真的视频生成',
        realisticVideoDescription:
            '使用简单的参考图像来生成逼真且细节丰富的视频。',

        // 更深入的提示理解
        deeperPromptTitle: '更深入的提示理解',
        deeperPromptDescription: '以无可挑剔的准确性遵循复杂而详细的提示。',

        // 改进的视觉一致性
        visualConsistencyTitle: '改进的视觉一致性',
        visualConsistencyDescription:
            '保持角色、对象和风格的一致性，以在任何环境中模拟真实世界的物理。',

        // 增强的相机控制
        cameraControlTitle: '增强的相机控制',
        cameraControlDescription:
            '更轻松地操纵场景中的多个主体动作和相机视角。',

        // 更快的视频创建
        fasterVideoTitle: '更快的视频创建',
        fasterVideoDescription:
            '通过 Gen-4 Turbo 模型，每 10 秒视频的生成速度提高 30 秒。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',
        step1Title: '选择Runway模型',
        step1Description:
            '前往<span >"AI视频生成"</span>页面，然后在模型下拉菜单中点击"Runway"。',
        step2Title: '输入您的创意内容',
        step2Description:
            '描述您想要生成的内容，或上传图片进行转换，并选择您喜欢的视频配置。',
        step3Title: '下载您的视频',
        step3Description: '点击"创建"，即可随意下载或分享生成的视频。',

        // YouTube 视频部分
        youtubeTitle: '关于 Runway Gen-4 模型的 YouTube 视频',
        youtubeVideosTitle: '关于 Runway Gen-4 模型的 YouTube 视频',
        youtubeVideoTitle: '关于 Runway Gen-4 模型的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Runway Gen-4 模型的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: 'Explore Other Models',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        veo3Title: 'Google Veo 3.1 AI Video Generator',
        wanAITitle: 'Wan AI 视频生成器',
        klingTitle: 'kling 2.5 视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',
        faq1Question: 'Runway AI是什么?',
        faq1Answer:
            'Runway AI是一款领先的AI视频生成平台，提供文本转视频、图像转视频、智能视频编辑等多种强大的视频创作工具，让创作者能够轻松制作专业级视频内容。',
        faq2Question: 'Runway AI有哪些主要功能?',
        faq2Answer:
            'Runway AI主要功能包括：文本转视频、图像转视频、智能视频编辑、创意工具套件等。它能够根据文字描述生成视频，将静态图像转换为动态视频，并提供强大的视频编辑功能。',
        faq3Question: '我能免费使用Runway AI吗?',
        faq3Answer:
            '是的。Runway AI通过WeryAI的免费试用提供有限的免费额度。如需大量使用，则需要升级。',
        faq4Question: 'Runway AI支持哪些视频格式?',
        faq4Answer:
            'Runway AI支持多种主流视频格式，包括MP4、MOV、AVI等。生成的视频质量高，适合各种用途，从社交媒体分享到专业视频制作。',
        faq5Question: '我可以使用 Runway AI用于专业或商业项目吗?',
        faq5Answer:
            '是的。Runway AI的高质量视频生成和强大的编辑功能使其成为专业视频制作人、内容创作者和商业用户的有力选择。',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaSubtitle: '立即体验 Runway，将您的创意转化为精彩视频',
        ctaDescription: '立即体验 Runway，将您的创意转化为精彩视频',
        ctaButton: '开始创作',
        ctaNote: '无需信用卡',
        ctaDisclaimer: '无需信用卡 · 新用户免费体验',

        // Runway Gen-4.5
        runway45Title: 'Runway Gen-4.5',
        runway45Desc: '前所未有的视觉保真度和创意控制，电影级和高度逼真',

        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoUnsupported: '您的浏览器不支持视频播放',
        videoLoadingError: '视频加载失败',
        videoLoadError: '视频加载失败',
        videoReload: '重新加载',
    },
    en: {
        // Page title and description
        pageTitle:
            'Runway Gen-4 Video Generator - Professional Video Creation Tool',
        pageDescription:
            'Experience the Runway Gen-4 Video Generator with text-to-video, image-to-video, and intelligent video editing features. Create professional AI videos for free on WeryAI.',
        pageKeywords:
            'Runway Gen-4, Runway AI, AI video generator, text to video, image to video, video editing, free AI video, WeryAI, video production',

        // Generator section
        generatorTitle: 'Runway Gen-4 Video Generator',
        generatorDescription:
            'Runway Gen-4 and Gen-4 Turbo are the latest <span >AI video generation models</span> from Runway. Building upon the previous Gen-3 Alpha Turbo model, this new version significantly improves <span >prompt adherence and motion realism</span>, as well as <span >character, style, and object consistency</span> across scenes. Try Runway Gen-4 Turbo now on the <span >WeryAI Video Generator</span>!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Key Features of Runway Gen-4',
        coreFeaturesSubtitle:
            'Explore the core features of the Runway Gen-4 AI Video Generator and start your revolutionary AI video creation journey',

        // Realistic video generation
        realisticVideoTitle: 'Realistic Video Generation',
        realisticVideoDescription:
            'Use simple reference images to generate realistic and detail-rich videos.',

        // Deeper prompt understanding
        deeperPromptTitle: 'Deeper Prompt Understanding',
        deeperPromptDescription:
            'Follow complex and detailed prompts with impeccable accuracy.',

        // Improved visual consistency
        visualConsistencyTitle: 'Improved Visual Consistency',
        visualConsistencyDescription:
            'Maintain consistency of characters, objects, and styles to simulate real-world physics in any environment.',

        // Enhanced camera control
        cameraControlTitle: 'Enhanced Camera Control',
        cameraControlDescription:
            'More easily manipulate multiple subject movements and camera perspectives in scenes.',

        // Faster video creation
        fasterVideoTitle: 'Faster Video Creation',
        fasterVideoDescription:
            'With the Gen-4 Turbo model, generation speed increases by 30 seconds for every 10 seconds of video.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',
        step1Title: 'Select Runway Model',
        step1Description:
            'Go to the <span >"AI Video Generation"</span> page, then click "Runway" in the model dropdown menu.',
        step2Title: 'Enter Your Creative Content',
        step2Description:
            'Describe what you want to generate, or upload images for conversion, and select your preferred video configuration.',
        step3Title: 'Download Your Video',
        step3Description:
            'Click "Create" to download or share your generated video as you wish.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Runway Gen-4 Model',
        youtubeVideosTitle: 'YouTube Videos About Runway Gen-4 Model',
        youtubeVideoTitle: 'YouTube Videos About Runway Gen-4 Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Runway Gen-4 Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Models',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        veo3Title: 'Google Veo 3.1 AI Video Generator',
        wanAITitle: 'Wan AI Video Generator',
        klingTitle: 'Kling 2.5 Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is Runway AI?',
        faq1Answer:
            'Runway AI is a leading AI video generation platform that offers powerful video creation tools including text-to-video, image-to-video, and intelligent video editing, enabling creators to easily produce professional-level video content.',
        faq2Question: 'What are the main features of Runway AI?',
        faq2Answer:
            'Main features of Runway AI include: text-to-video, image-to-video, intelligent video editing, and creative tool suites. It can generate videos from text descriptions, convert static images into dynamic videos, and provide powerful video editing capabilities.',
        faq3Question: 'Can I use Runway AI for free?',
        faq3Answer:
            'Yes. Runway AI offers limited free credits through WeryAI\'s free trial. For extensive use, an upgrade is required.',
        faq4Question: 'What video formats does Runway AI support?',
        faq4Answer:
            'Runway AI supports multiple mainstream video formats including MP4, MOV, AVI, and more. Generated videos are high quality and suitable for various purposes, from social media sharing to professional video production.',
        faq5Question:
            'Can I use Runway AI for professional or commercial projects?',
        faq5Answer:
            'Yes. Runway AI\'s high-quality video generation and powerful editing features make it an excellent choice for professional video producers, content creators, and commercial users.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaSubtitle:
            'Experience Runway now and transform your creativity into amazing videos',
        ctaDescription:
            'Experience Runway now and transform your creativity into amazing videos',
        ctaButton: 'Start Creating',
        ctaNote: 'No credit card required',
        ctaDisclaimer: 'No credit card required · Free trial for new users',

        // Runway Gen-4.5
        runway45Title: 'Runway Gen-4.5',
        runway45Desc:
            'Unprecedented visual fidelity and creative control, cinematic and highly realistic',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoUnsupported: 'Your browser does not support video playback',
        videoLoadingError: 'Video loading failed',
        videoLoadError: 'Video loading failed',
        videoReload: 'Reload',
    },
    ja: {
        // ページタイトルと説明
        pageTitle:
            'Runway AI動画ジェネレーター - リーディングAI動画作成プラットフォーム',
        pageDescription:
            'Runway AI動画ジェネレーターを体験。テキストから動画、画像から動画、動画編集などの機能をサポート。複数の強力な動画作成ツールを提供し、プロフェッショナルな動画コンテンツを簡単に作成。WeryAIプラットフォームで無料試用。',
        pageKeywords:
            'Runway AI, AI動画ジェネレーター, AI動画作成, 人工知能動画, 動画生成ツール, 無料AI動画, 微鲤AI, 動画制作',

        // ジェネレーター部分
        generatorTitle: 'Runway AI動画ジェネレーター',
        generatorDescription:
            'Runwayは、複数の強力な動画作成ツールを提供するリーディングAI動画生成プラットフォームです。テキストから動画、画像から動画、動画編集などの機能をサポートし、クリエイターがプロフェッショナルグレードの動画コンテンツを簡単に作成できるようにします。WeryAI動画ジェネレーターでRunwayを無料でお試しください！',

        // タブ
        tabImageToVideo: '画像から動画',
        tabTextToVideo: 'テキストから動画',

        // コア機能部分
        coreFeaturesTitle: 'Runway の主要機能',
        coreFeaturesSubtitle:
            'Runway Gen-4 AI動画ジェネレーターのコア機能を探索し、革命的なAI動画作成の旅を始めましょう',

        // テキストから動画機能
        textToVideoTitle: 'テキストから動画',
        textToVideoDescription:
            'Runwayはあなたのテキスト記述に基づいて高品質の動画コンテンツを生成でき、複数のスタイルとシーンをサポートし、あなたの創造的なアイデアを迅速に視覚的コンテンツに変換できます。',

        // 画像から動画機能
        imageToVideoTitle: '画像から動画',
        imageToVideoDescription:
            '静的画像を動的動画に変換し、あなたの画像に生き生きとしたアニメーション効果を追加し、静的コンテンツに新しい命を吹き込みます。',

        // 動画編集機能
        videoEditingTitle: 'インテリジェント動画編集',
        videoEditingDescription:
            'オブジェクト削除、背景置換、スタイル変換などの強力な動画編集機能を提供し、プロフェッショナルグレードの動画コンテンツを簡単に作成できます。',

        // クリエイティブツール機能
        creativeToolsTitle: 'クリエイティブツールスイート',
        creativeToolsDescription:
            'スタイル変換、エフェクト追加、色調整などの豊富なクリエイティブツールを提供し、あなたの動画作成をよりカラフルにします。',

        // 使用方法部分
        howToUseTitle: '使用方法',
        howToUseSubtitle: '簡単3ステップで開始',
        step1Title: 'Runwayモデル選択',
        step1Description:
            '「AI動画生成」ページに移動し、モデルドロップダウンメニューで「Runway」をクリックします。',
        step2Title: 'コンテンツ入力',
        step2Description: 'プロンプトを入力または参照画像をアップロード',
        step3Title: '動画生成',
        step3Description: '生成ボタンをクリックし、待機して動画をダウンロード',

        // YouTube動画部分
        youtubeTitle: 'Runway AI動画ジェネレーターに関するYouTube動画',
        youtubeVideosTitle: 'Runway AI動画ジェネレーターに関するYouTube動画',
        youtubeVideoTitle: 'Runway AI動画ジェネレーターに関するYouTube動画',

        // X投稿部分
        xPostsTitle: 'Runway AI動画ジェネレーターに関するX投稿',

        // 他のモデル探索部分
        exploreModelsTitle: '他の動画モデルを探索',
        sora2Title: 'OpenAI Sora-2 AI動画ジェネレーター',
        veo3Title: 'Google Veo 3 AI動画ジェネレーター',
        wanAITitle: 'Wan AI動画ジェネレーター',
        klingTitle: 'kling 2.5動画ジェネレーター',

        // FAQ部分
        faqTitle: 'よくある質問',
        faq1Question: 'Runway AIとは何ですか？',
        faq1Answer:
            'Runway AIは、複数の強力な動画作成ツールを提供するリーディングAI動画生成プラットフォームです。テキストから動画、画像から動画、動画編集などの機能をサポートし、クリエイターがプロフェッショナルグレードの動画コンテンツを簡単に作成できるようにします。',
        faq2Question: 'Runway AIの特別な機能は何ですか？',
        faq2Answer:
            'Runway AIの主な特別な機能には以下が含まれます：1）テキスト記述に基づいて高品質動画を生成するテキストから動画；2）静的画像を動的動画に変換する画像から動画；3）オブジェクト削除、背景置換などの機能を提供するインテリジェント動画編集；4）スタイル変換、エフェクト追加などを含むクリエイティブツールスイート。',
        faq3Question: 'WeryAIでRunway AIを無料で使用できますか？',
        faq3Answer:
            'はい！WeryAIはRunway AIの無料試用サービスを提供しています。アカウントを登録してすぐに使用を開始し、Runway AIの強力な機能を体験できます。ユーザーが体験するための一定の無料クレジットを提供し、無料クォータを超えた後はより多くのクレジットを購入して継続使用できます。',
        faq4Question:
            'Runway AIはどのような動画編集機能をサポートしていますか？',
        faq4Answer:
            'Runway AIはオブジェクト削除、背景置換、スタイル変換、エフェクト追加、色調整などの複数の動画編集機能をサポートしています。これらの機能により、複雑なポストプロダクションスキルなしにプロフェッショナルグレードの動画コンテンツを簡単に作成できます。',
        faq5Question: 'Runway AIの生成品質はどうですか？',
        faq5Answer:
            'Runway AIは先進的なAI技術を使用して高品質の動画コンテンツを生成します。複数のスタイルとシーンをサポートし、生成された動画がプロフェッショナルグレードの品質基準を満たし、異なる創造的ニーズを満たすことを保証します。',
        faq6Question: 'Runway AIはどのようなタイプの動画作成に適していますか？',
        faq6Answer:
            'Runway AIは以下のような様々なタイプの動画作成に適しています：1）創造的な短編映画制作；2）製品紹介動画；3）ソーシャルメディアコンテンツ作成；4）教育コンテンツ制作；5）商業広告制作など。',

        // CTA部分
        ctaTitle: '作成を始める準備はできましたか？',
        ctaSubtitle:
            '今すぐRunway AIを体験し、あなたの創造性を素晴らしい動画に変換',
        ctaDescription:
            '今すぐRunway AIを体験し、あなたの創造性を素晴らしい動画に変換',
        ctaButton: 'WeryAIでRunway AIを試す',
        ctaNote: 'クレジットカード不要',
        ctaDisclaimer: 'クレジットカード不要',

        // Runway Gen-4.5
        runway45Title: 'Runway Gen-4.5',
        runway45Desc:
            '前例のない視覚的忠実度とクリエイティブコントロール、映画的で非常にリアル',

        // 動画再生関連
        videoNotSupported: 'お使いのブラウザは動画再生をサポートしていません',
        videoUnsupported: 'お使いのブラウザは動画再生をサポートしていません',
        videoLoadingError: '動画の読み込みに失敗しました',
        videoLoadError: '動画の読み込みに失敗しました',
        videoReload: '再読み込み',
        realisticVideoTitle: 'リアルな動画生成',
        realisticVideoDescription: 'シンプルな参照画像を使用して、リアルで詳細に富んだ動画を生成します。',
        deeperPromptTitle: 'より深いプロンプト理解',
        deeperPromptDescription: '完璧な精度で複雑で詳細なプロンプトに従います。',
        visualConsistencyTitle: '視覚的一貫性の向上',
        visualConsistencyDescription: 'キャラクター、オブジェクト、スタイルの一貫性を維持し、あらゆる環境で現実世界の物理をシミュレートします。',
        cameraControlTitle: '強化されたカメラコントロール',
        cameraControlDescription: 'シーン内の複数の被写体の動きとカメラアングルをより簡単に操作できます。',
        fasterVideoTitle: 'より高速な動画作成',
        fasterVideoDescription: 'Gen-4 Turboモデルにより、10秒の動画あたりの生成速度が30秒向上します。',
    },
    ko: {
        // 페이지 제목과 설명
        pageTitle: 'Runway AI 비디오 생성기 - 선도적인 AI 비디오 제작 플랫폼',
        pageDescription:
            'Runway AI 비디오 생성기를 체험하세요. 텍스트에서 비디오, 이미지에서 비디오, 비디오 편집 등의 기능을 지원합니다. 여러 강력한 비디오 제작 도구를 제공하여 전문적인 비디오 콘텐츠를 쉽게 만들 수 있습니다. 微鲤AI 플랫폼에서 무료로 체험하세요.',
        pageKeywords:
            'Runway AI, AI 비디오 생성기, AI 비디오 제작, 인공지능 비디오, 비디오 생성 도구, 무료 AI 비디오, 微鲤AI, 비디오 제작',

        // 생성기 부분
        generatorTitle: 'Runway AI 비디오 생성기',
        generatorDescription:
            'Runway는 여러 강력한 비디오 제작 도구를 제공하는 선도적인 AI 비디오 생성 플랫폼입니다. 텍스트에서 비디오, 이미지에서 비디오, 비디오 편집 등의 기능을 지원하여 창작자가 전문가급 비디오 콘텐츠를 쉽게 만들 수 있도록 합니다. 微鲤AI 비디오 생성기에서 Runway를 무료로 체험해보세요!',

        // 탭
        tabImageToVideo: '이미지에서 비디오',
        tabTextToVideo: '텍스트에서 비디오',

        // 핵심 기능 부분
        coreFeaturesTitle: 'Runway 주요 기능',
        coreFeaturesSubtitle:
            'Runway Gen-4 AI 비디오 생성기의 핵심 기능을 탐색하고 혁신적인 AI 비디오 제작 여정을 시작하세요',

        // 텍스트에서 비디오 기능
        textToVideoTitle: '텍스트에서 비디오',
        textToVideoDescription:
            'Runway는 당신의 텍스트 설명에 기반하여 고품질의 비디오 콘텐츠를 생성할 수 있으며, 여러 스타일과 장면을 지원하여 당신의 창의적인 아이디어를 빠르게 시각적 콘텐츠로 변환할 수 있습니다.',

        // 이미지에서 비디오 기능
        imageToVideoTitle: '이미지에서 비디오',
        imageToVideoDescription:
            '정적 이미지를 동적 비디오로 변환하여 당신의 이미지에 생생한 애니메이션 효과를 추가하고 정적 콘텐츠에 새로운 생명을 불어넣습니다.',

        // 비디오 편집 기능
        videoEditingTitle: '지능형 비디오 편집',
        videoEditingDescription:
            '객체 제거, 배경 교체, 스타일 변환 등을 포함한 강력한 비디오 편집 기능을 제공하여 전문가급 비디오 콘텐츠를 쉽게 만들 수 있습니다.',

        // 창의적 도구 기능
        creativeToolsTitle: '창의적 도구 세트',
        creativeToolsDescription:
            '스타일 변환, 효과 추가, 색상 조정 등의 풍부한 창의적 도구를 제공하여 당신의 비디오 제작을 더욱 다채롭게 만듭니다.',

        // 사용 방법 부분
        howToUseTitle: '사용 방법',
        howToUseSubtitle: '간단한 3단계로 시작',
        step1Title: 'Runway 모델 선택',
        step1Description:
            '"AI 비디오 생성" 페이지로 이동한 다음 모델 드롭다운 메뉴에서 "Runway"를 클릭합니다.',
        step2Title: '콘텐츠 입력',
        step2Description: '프롬프트 입력 또는 참조 이미지 업로드',
        step3Title: '비디오 생성',
        step3Description: '생성 버튼 클릭, 대기 후 비디오 다운로드',

        // YouTube 비디오 부분
        youtubeTitle: 'Runway AI 비디오 생성기에 대한 YouTube 비디오',
        youtubeVideosTitle: 'Runway AI 비디오 생성기에 대한 YouTube 비디오',
        youtubeVideoTitle: 'Runway AI 비디오 생성기에 대한 YouTube 비디오',

        // X 게시물 부분
        xPostsTitle: 'Runway AI 비디오 생성기에 대한 X 게시물',

        // 다른 모델 탐색 부분
        exploreModelsTitle: '다른 비디오 모델 탐색',
        sora2Title: 'OpenAI Sora-2 AI 비디오 생성기',
        veo3Title: 'Google Veo 3 AI 비디오 생성기',
        wanAITitle: 'Wan AI 비디오 생성기',
        klingTitle: 'kling 2.5 비디오 생성기',

        // FAQ 부분
        faqTitle: '자주 묻는 질문',
        faq1Question: 'Runway AI가 무엇인가요?',
        faq1Answer:
            'Runway AI는 여러 강력한 비디오 제작 도구를 제공하는 선도적인 AI 비디오 생성 플랫폼입니다. 텍스트에서 비디오, 이미지에서 비디오, 비디오 편집 등의 기능을 지원하여 창작자가 전문가급 비디오 콘텐츠를 쉽게 만들 수 있도록 합니다.',
        faq2Question: 'Runway AI의 특별한 기능은 무엇인가요?',
        faq2Answer:
            'Runway AI의 주요 특별한 기능은 다음과 같습니다: 1) 텍스트 설명에 기반하여 고품질 비디오를 생성하는 텍스트에서 비디오; 2) 정적 이미지를 동적 비디오로 변환하는 이미지에서 비디오; 3) 객체 제거, 배경 교체 등의 기능을 제공하는 지능형 비디오 편집; 4) 스타일 변환, 효과 추가 등을 포함한 창의적 도구 세트.',
        faq3Question: 'WeryAI에서 Runway AI를 무료로 사용할 수 있나요?',
        faq3Answer:
            '네! WeryAI는 Runway AI의 무료 체험 서비스를 제공합니다. 계정을 등록하고 즉시 사용을 시작하여 Runway AI의 강력한 기능을 체험할 수 있습니다. 사용자가 체험할 수 있는 일정한 무료 크레딧을 제공하며, 무료 할당량을 초과한 후에는 더 많은 크레딧을 구매하여 계속 사용할 수 있습니다.',
        faq4Question: 'Runway AI는 어떤 비디오 편집 기능을 지원하나요?',
        faq4Answer:
            'Runway AI는 객체 제거, 배경 교체, 스타일 변환, 효과 추가, 색상 조정 등을 포함한 여러 비디오 편집 기능을 지원합니다. 이러한 기능을 통해 복잡한 포스트 프로덕션 기술 없이도 전문가급 비디오 콘텐츠를 쉽게 만들 수 있습니다.',
        faq5Question: 'Runway AI의 생성 품질은 어떤가요?',
        faq5Answer:
            'Runway AI는 고급 AI 기술을 사용하여 고품질의 비디오 콘텐츠를 생성합니다. 여러 스타일과 장면을 지원하여 생성된 비디오가 전문가급 품질 기준을 충족하고 다양한 창의적 요구사항을 만족하도록 보장합니다.',
        faq6Question: 'Runway AI는 어떤 유형의 비디오 제작에 적합한가요?',
        faq6Answer:
            'Runway AI는 다음과 같은 다양한 유형의 비디오 제작에 적합합니다: 1) 창의적인 단편 영화 제작; 2) 제품 쇼케이스 비디오; 3) 소셜 미디어 콘텐츠 제작; 4) 교육 콘텐츠 제작; 5) 상업 광고 제작 등.',

        // CTA 부분
        ctaTitle: '제작을 시작할 준비가 되셨나요?',
        ctaSubtitle:
            '지금 Runway AI를 체험하고 당신의 창의성을 놀라운 비디오로 변환하세요',
        ctaDescription:
            '지금 Runway AI를 체험하고 당신의 창의성을 놀라운 비디오로 변환하세요',
        ctaButton: 'WeryAI에서 Runway AI 체험하기',
        ctaNote: '신용카드 불필요',
        ctaDisclaimer: '신용카드 불필요',

        // Runway Gen-4.5
        runway45Title: 'Runway Gen-4.5',
        runway45Desc:
            '전례 없는 시각적 충실도와 창의적 제어, 영화적이고 매우 사실적',

        // 비디오 재생 관련
        videoNotSupported: '귀하의 브라우저는 비디오 재생을 지원하지 않습니다',
        videoUnsupported: '귀하의 브라우저는 비디오 재생을 지원하지 않습니다',
        videoLoadingError: '비디오 로딩 실패',
        videoLoadError: '비디오 로딩 실패',
        videoReload: '다시 로드',
        realisticVideoTitle: '사실적인 비디오 생성',
        realisticVideoDescription: '간단한 참조 이미지를 사용하여 사실적이고 디테일이 풍부한 비디오를 생성합니다.',
        deeperPromptTitle: '더 깊은 프롬프트 이해',
        deeperPromptDescription: '복잡하고 상세한 프롬프트를 완벽한 정확도로 따릅니다.',
        visualConsistencyTitle: '향상된 시각적 일관성',
        visualConsistencyDescription: '캐릭터, 객체 및 스타일의 일관성을 유지하여 어떤 환경에서도 현실 세계의 물리를 시뮬레이션합니다.',
        cameraControlTitle: '향상된 카메라 제어',
        cameraControlDescription: '장면 내 여러 피사체의 움직임과 카메라 각도를 더 쉽게 조작할 수 있습니다.',
        fasterVideoTitle: '더 빠른 비디오 생성',
        fasterVideoDescription: 'Gen-4 Turbo 모델을 통해 10초 비디오당 생성 속도가 30초 향상됩니다.',
    },
    tw: {
        // 頁面標題和描述
        pageTitle: 'Runway Gen-4 影片產生器 - 專業 AI 影片創作工具',
        pageDescription:
            '體驗 Runway Gen-4 影片產生器，支援文字轉影片、圖像轉影片、智慧影片編輯等功能。建立專業 AI 影片，在 微鲤AI 平台免費試用。',
        pageKeywords:
            'Runway Gen-4, Runway AI, AI 影片產生器, text to video, image to video, 影片編輯, 免費 AI 影片, 微鲤AI, 影片製作',

        // 生成器部分
        generatorTitle: 'Runway Gen-4 影片產生器',
        generatorDescription:
            'Runway Gen-4 和 Gen-4 Turbo 是 Runway 最新推出的 <span >AI 影片生成模型</span>。基於之前的 Gen-3 Alpha Turbo 模型，這個新版本顯著提升了<span >提示詞的遵循度和動作的真實感</span>，以及跨場景的<span >角色、風格和物體的一致性</span>。現在就來 <span >微鲤AI 影片產生器體驗 Runway Gen-4 Turbo</span>！',

        // 標籤頁
        tabImageToVideo: '圖生影片',
        tabTextToVideo: '文生影片',

        // 核心功能部分
        coreFeaturesTitle: 'Runway Gen-4 的主要功能',
        coreFeaturesSubtitle:
            '探索 Runway Gen-4 AI 影片產生器的核心功能，開啟革命性的 AI 影片創作之旅',

        // 逼真的影片生成
        realisticVideoTitle: '超寫實影片生成',
        realisticVideoDescription: '僅需簡單的參考圖片，即可生成高品質且細節豐富的影片。',

        // 更深入的提示理解
        deeperPromptTitle: '深層提示語理解',
        deeperPromptDescription: '以無可挑剔的準確性遵循複雜而詳細的提示。',

        // 改進的視覺一致性
        visualConsistencyTitle: '提升的視覺一致性',
        visualConsistencyDescription:
            '保持角色、物件和風格的一致性，以在任何環境中模擬真實世界的物理。',

        // 增強的相機控制
        cameraControlTitle: '增強的相機控制',
        cameraControlDescription:
            '更輕鬆地操縱場景中的多個主體動作和相機視角。',

        // 更快的影片建立
        fasterVideoTitle: '更快的影片建立',
        fasterVideoDescription:
            '透過 Gen-4 Turbo 模型，每 10 秒影片的生成速度提高 30 秒。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        howToUseSubtitle: '簡單三步，開始創作',
        step1Title: '選擇 Runway 模型',
        step1Description:
            '前往<span >「AI 影片生成」</span>頁面，然後在模型下拉選單中點擊「Runway」。',
        step2Title: '輸入您的創意內容',
        step2Description:
            '描述您想要生成的內容，或上傳圖片進行轉換，並選擇您喜歡的影片配置。',
        step3Title: '下載您的影片',
        step3Description: '點擊「建立」，即可隨意下載或分享生成的影片。',

        // YouTube 影片部分
        youtubeTitle: '關於 Runway Gen-4 模型的 YouTube 影片',
        youtubeVideosTitle: '關於 Runway Gen-4 模型的 YouTube 影片',
        youtubeVideoTitle: '關於 Runway Gen-4 模型的 YouTube 影片',

        // X Posts 部分
        xPostsTitle: '關於 Runway Gen-4 模型的人門 X 貼文',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他模型',
        sora2Title: 'OpenAI Sora-2 AI 影片產生器',
        veo3Title: 'Google Veo 3.1 AI 影片產生器',
        wanAITitle: 'Wan AI 影片產生器',
        klingTitle: 'Kling 2.5 影片產生器',

        // FAQ 部分
        faqTitle: '常見問題解答',
        faq1Question: 'Runway AI 是什麼？',
        faq1Answer:
            'Runway AI 是一款領先的 AI 影片生成平台，提供文字轉影片、圖像轉影片、智慧影片編輯等多種強大的影片創作工具，讓創作者能夠輕鬆製作專業級影片內容。',
        faq2Question: 'Runway AI 有哪些主要功能？',
        faq2Answer:
            'Runway AI 主要功能包括：文字轉影片、圖像轉影片、智慧影片編輯、創意工具套件等。它能夠根據文字描述生成影片，將靜態圖像轉換為動態影片，並提供強大的影片編輯功能。',
        faq3Question: '我能免費使用 Runway AI 嗎？',
        faq3Answer:
            '是的。Runway AI 透過 微鲤AI 的免費試用提供有限的免費額度。如需大量使用，則需要升級。',
        faq4Question: 'Runway AI 支援哪些影片格式？',
        faq4Answer:
            'Runway AI 支援多種主流影片格式，包括 MP4、MOV、AVI 等。生成的影片品質高，適合各種用途，從社群媒體分享到專業影片製作。',
        faq5Question: '我可以使用 Runway AI 用於專業或商業項目嗎？',
        faq5Answer:
            '是的。Runway AI 的高品質影片生成和強大的編輯功能使其成為專業影片製作人、內容創作者和商業用戶的有力選擇。',

        // CTA 部分
        ctaTitle: '準備開始創作了嗎？',
        ctaSubtitle: '立即體驗 Runway，將您的創意轉化為精彩影片',
        ctaDescription: '立即體驗 Runway，將您的創意轉化為精彩影片',
        ctaButton: '開始創作',
        ctaNote: '無需信用卡',
        ctaDisclaimer: '無需信用卡 · 新用戶免費體驗',

        // Runway Gen-4.5
        runway45Title: 'Runway Gen-4.5',
        runway45Desc: '前所未有的視覺保真度和創意控制，電影級和高度逼真',

        // 影片播放相關
        videoNotSupported: '您的瀏覽器不支援影片播放',
        videoUnsupported: '您的瀏覽器不支援影片播放',
        videoLoadingError: '影片載入失敗',
        videoLoadError: '影片載入失敗',
        videoReload: '重新載入',
    },
    pl: {
        // Page title and description
        pageTitle: 'Generator wideo Runway Gen-4 – profesjonalne narzędzie AI',
        pageDescription:
            'Wypróbuj generator wideo Runway Gen-4 z funkcjami tekst-na-wideo, obraz-na-wideo i inteligentną edycją wideo. Twórz profesjonalne filmy AI za darmo na platformie 微鲤AI.',
        pageKeywords:
            'Runway Gen-4, Runway AI, generator wideo AI, tekst na wideo, obraz na wideo, edycja wideo, darmowe wideo AI, 微鲤AI, produkcja wideo',

        // Generator section
        generatorTitle: 'Generator wideo Runway Gen-4',
        generatorDescription:
            'Runway Gen-4 i Gen-4 Turbo to najnowsze <span >modele generowania wideo AI</span> od Runway. Oparte na poprzednim modelu Gen-3 Alpha Turbo, ta nowa wersja znacząco poprawia <span >zgodność z promptami i realizm ruchu</span>, a także <span >spójność postaci, stylu i obiektów</span> między scenami. Wypróbuj Runway Gen-4 Turbo już teraz w <span >generatorze wideo 微鲤AI</span>!',

        // Tabs
        tabImageToVideo: 'Obraz na wideo',
        tabTextToVideo: 'Tekst na wideo',

        // Core features section
        coreFeaturesTitle: 'Główne funkcje Runway Gen-4',
        coreFeaturesSubtitle:
            'Poznaj kluczowe funkcje generatora wideo AI Runway Gen-4 i rozpocznij rewolucyjną podróż w tworzeniu wideo AI',

        // Realistic video generation
        realisticVideoTitle: 'Realistyczne generowanie wideo',
        realisticVideoDescription:
            'Użyj prostych obrazów referencyjnych, aby wygenerować realistyczne i bogate w szczegóły filmy.',

        // Deeper prompt understanding
        deeperPromptTitle: 'Głębsze zrozumienie promptów',
        deeperPromptDescription:
            'Podąża za złożonymi i szczegółowymi promptami z nienaganną dokładnością.',

        // Improved visual consistency
        visualConsistencyTitle: 'Poprawiona spójność wizualna',
        visualConsistencyDescription:
            'Utrzymuje spójność postaci, obiektów i stylów, aby symulować fizykę świata rzeczywistego w dowolnym środowisku.',

        // Enhanced camera control
        cameraControlTitle: 'Ulepszona kontrola kamery',
        cameraControlDescription:
            'Łatwiejsze manipulowanie ruchami wielu obiektów i perspektywami kamery w scenie.',

        // Faster video creation
        fasterVideoTitle: 'Szybsze tworzenie wideo',
        fasterVideoDescription:
            'Dzięki modelowi Gen-4 Turbo prędkość generowania wzrasta o 30 sekund na każde 10 sekund wideo.',

        // How to use section
        howToUseTitle: 'Jak używać',
        howToUseSubtitle: 'Trzy proste kroki, aby zacząć',
        step1Title: 'Wybierz model Runway',
        step1Description:
            'Przejdź do strony <span >"Generowanie wideo AI"</span>, a następnie kliknij "Runway" w rozwijanym menu modeli.',
        step2Title: 'Wprowadź swoją kreatywną treść',
        step2Description:
            'Opisz, co chcesz wygenerować lub prześlij obrazy do konwersji i wybierz preferowaną konfigurację wideo.',
        step3Title: 'Pobierz swoje wideo',
        step3Description:
            'Kliknij "Utwórz", aby swobodnie pobrać lub udostępnić wygenerowane wideo.',

        // YouTube videos section
        youtubeTitle: 'Filmy na YouTube o modelu Runway Gen-4',
        youtubeVideosTitle: 'Filmy na YouTube o modelu Runway Gen-4',
        youtubeVideoTitle: 'Filmy na YouTube o modelu Runway Gen-4',

        // X Posts section
        xPostsTitle: 'Popularne posty na X o modelu Runway Gen-4',

        // Explore other models section
        exploreModelsTitle: 'Poznaj inne modele',
        sora2Title: 'Generator wideo AI OpenAI Sora-2',
        veo3Title: 'Generator wideo AI Google Veo 3.1',
        wanAITitle: 'Generator wideo Wan AI',
        klingTitle: 'Generator wideo Kling 2.5',

        // FAQ section
        faqTitle: 'Często zadawane pytania',
        faq1Question: 'Co to jest Runway AI?',
        faq1Answer:
            'Runway AI to wiodąca platforma do generowania wideo AI, która oferuje wiele potężnych narzędzi do tworzenia wideo, takich jak tekst-na-wideo, obraz-na-wideo i inteligentna edycja wideo, pozwalając twórcom łatwo produkować treści wideo profesjonalnej jakości.',
        faq2Question: 'Jakie są główne funkcje Runway AI?',
        faq2Answer:
            'Główne funkcje Runway AI to: tekst-na-wideo, obraz-na-wideo, inteligentna edycja wideo i zestawy narzędzi kreatywnych. Może generować filmy na podstawie opisów tekstowych, konwertować statyczne obrazy w dynamiczne wideo i oferować potężne możliwości edycji wideo.',
        faq3Question: 'Czy mogę korzystać z Runway AI za darmo?',
        faq3Answer:
            'Tak. Runway AI jest dostępne w ramach bezpłatnej wersji próbnej 微鲤AI z ograniczoną liczbą darmowych kredytów. Przy intensywnym użytkowaniu wymagana będzie aktualizacja subskrypcji.',
        faq4Question: 'Jakie formaty wideo obsługuje Runway AI?',
        faq4Answer:
            'Runway AI obsługuje wiele popularnych formatów wideo, w tym MP4, MOV, AVI itp. Wygenerowane filmy są wysokiej jakości, odpowiednie do różnych celów, od udostępniania w mediach społecznościowych po profesjonalną produkcję wideo.',
        faq5Question:
            'Czy mogę używać Runway AI do projektów profesjonalnych lub komercyjnych?',
        faq5Answer:
            'Tak. Wysoka jakość generowania wideo Runway AI i potężne funkcje edycji sprawiają, że jest to doskonały wybór dla profesjonalnych producentów wideo, twórców treści i użytkowników komercyjnych.',

        // CTA section
        ctaTitle: 'Gotowy, aby zacząć tworzyć?',
        ctaSubtitle:
            'Doświadcz Runway już teraz i przekształć swoją kreatywność w niesamowite filmy',
        ctaDescription:
            'Doświadcz Runway już teraz i przekształć swoją kreatywność w niesamowite filmy',
        ctaButton: 'Zacznij tworzyć',
        ctaNote: 'Karta kredytowa nie jest wymagana',
        ctaDisclaimer: 'Karta kredytowa nie jest wymagana · Darmowy okres próbny dla nowych użytkowników',

        // Runway Gen-4.5
        runway45Title: 'Runway Gen-4.5',
        runway45Desc:
            'Niespotykana wierność wizualna i kontrola kreatywna, kinowa i wysoce realistyczna',

        // Video playback related
        videoNotSupported: 'Twoja przeglądarka nie obsługuje odtwarzania wideo',
        videoUnsupported: 'Twoja przeglądarka nie obsługuje odtwarzania wideo',
        videoLoadingError: 'Ładowanie wideo nie powiodło się',
        videoLoadError: 'Ładowanie wideo nie powiodło się',
        videoReload: 'Odśwież',
    },
    es: {
        // Título y descripción de la página
        pageTitle:
            'Generador de Video Runway Gen-4 - Herramienta Profesional de Creación de Video',
        pageDescription:
            'Experimenta el generador de video Runway Gen-4 con capacidades de texto a video, imagen a video y edición inteligente de video. Crea videos IA profesionales gratis en la plataforma 微鲤AI.',
        pageKeywords:
            'Runway Gen-4, Runway AI, generador de video IA, texto a video, imagen a video, edición de video, video IA gratis, 微鲤AI, producción de video',

        // Sección del generador
        generatorTitle: 'Generador de Video Runway Gen-4',
        generatorDescription:
            'Runway Gen-4 y Gen-4 Turbo son los más recientes <span >modelos de generación de video IA</span> de Runway. Basándose en el modelo anterior Gen-3 Alpha Turbo, esta nueva versión mejora significativamente <span >la adherencia a prompts y el realismo del movimiento</span>, así como la <span >consistencia de personajes, estilo y objetos</span> a través de escenas. ¡Experimenta Runway Gen-4 Turbo ahora en el <span >generador de video 微鲤AI</span>!',

        // Pestañas
        tabImageToVideo: 'Imagen a Video',
        tabTextToVideo: 'Texto a Video',

        // Sección de características principales
        coreFeaturesTitle: 'Características Principales de Runway Gen-4',
        coreFeaturesSubtitle:
            'Explora las características principales del generador de video IA Runway Gen-4 y embárcate en un viaje revolucionario de creación de video IA',

        // Generación de video realista
        realisticVideoTitle: 'Generación de Video Realista',
        realisticVideoDescription:
            'Usa imágenes de referencia simples para generar videos realistas y ricos en detalles.',

        // Comprensión más profunda de prompts
        deeperPromptTitle: 'Comprensión Más Profunda de Prompts',
        deeperPromptDescription:
            'Sigue prompts complejos y detallados con precisión impecable.',

        // Consistencia visual mejorada
        visualConsistencyTitle: 'Consistencia Visual Mejorada',
        visualConsistencyDescription:
            'Mantiene la consistencia de personajes, objetos y estilos para simular la física del mundo real en cualquier entorno.',

        // Control de cámara mejorado
        cameraControlTitle: 'Control de Cámara Mejorado',
        cameraControlDescription:
            'Manipula más fácilmente múltiples movimientos de sujetos y perspectivas de cámara en una escena.',

        // Creación de video más rápida
        fasterVideoTitle: 'Creación de Video Más Rápida',
        fasterVideoDescription:
            'A través del modelo Gen-4 Turbo, la velocidad de generación aumenta 30 segundos por cada 10 segundos de video.',

        // Sección cómo usar
        howToUseTitle: 'Cómo Usar',
        howToUseSubtitle: 'Tres simples pasos para comenzar',
        step1Title: 'Seleccionar Modelo Runway',
        step1Description:
            'Ve a la página <span >"Generación de Video IA"</span>, luego haz clic en "Runway" en el menú desplegable de modelos.',
        step2Title: 'Introduce Tu Contenido Creativo',
        step2Description:
            'Describe lo que quieres generar, o sube imágenes para conversión, y selecciona tu configuración de video preferida.',
        step3Title: 'Descarga Tu Video',
        step3Description:
            'Haz clic en "Crear" para descargar o compartir libremente tu video generado.',

        // Sección de videos de YouTube
        youtubeTitle: 'Videos de YouTube sobre el Modelo Runway Gen-4',
        youtubeVideosTitle: 'Videos de YouTube sobre el Modelo Runway Gen-4',
        youtubeVideoTitle: 'Videos de YouTube sobre el Modelo Runway Gen-4',

        // Sección de publicaciones X
        xPostsTitle:
            'Publicaciones Populares de X sobre el Modelo Runway Gen-4',

        // Sección explorar otros modelos
        exploreModelsTitle: 'Explorar Otros Modelos',
        sora2Title: 'Generador de Video IA OpenAI Sora-2',
        veo3Title: 'Generador de Video IA Google Veo 3.1',
        wanAITitle: 'Generador de Video Wan AI',
        klingTitle: 'Generador de Video kling 2.5',

        // Sección FAQ
        faqTitle: 'Preguntas Frecuentes',
        faq1Question: '¿Qué es Runway AI?',
        faq1Answer:
            'Runway AI es una plataforma líder de generación de video IA que proporciona múltiples herramientas poderosas de creación de video como texto a video, imagen a video y edición inteligente de video, permitiendo a los creadores producir fácilmente contenido de video de grado profesional.',
        faq2Question:
            '¿Cuáles son las características principales de Runway AI?',
        faq2Answer:
            'Las características principales de Runway AI incluyen: texto a video, imagen a video, edición inteligente de video y conjuntos de herramientas creativas. Puede generar videos basados en descripciones de texto, convertir imágenes estáticas en videos dinámicos y proporcionar capacidades de edición de video potentes.',
        faq3Question: '¿Puedo usar Runway AI gratis?',
        faq3Answer:
            'Sí. Runway AI está disponible a través de la prueba gratuita de 微鲤AI con créditos gratuitos limitados. Para uso intensivo, se requerirá una actualización.',
        faq4Question: '¿Qué formatos de video soporta Runway AI?',
        faq4Answer:
            'Runway AI soporta múltiples formatos de video principales incluyendo MP4, MOV, AVI, etc. Los videos generados son de alta calidad, adecuados para diversos propósitos desde compartir en redes sociales hasta producción de video profesional.',
        faq5Question:
            '¿Puedo usar Runway AI para proyectos profesionales o comerciales?',
        faq5Answer:
            'Sí. La generación de video de alta calidad y las potentes características de edición de Runway AI lo convierten en una opción sólida para productores de video profesionales, creadores de contenido y usuarios comerciales.',

        // Sección CTA
        ctaTitle: '¿Listo para Comenzar a Crear?',
        ctaSubtitle:
            'Experimenta Runway ahora y transforma tu creatividad en videos increíbles',
        ctaDescription:
            'Experimenta Runway ahora y transforma tu creatividad en videos increíbles',
        ctaButton: 'Prueba Runway en 微鲤AI',
        ctaNote: 'No se requiere tarjeta de crédito',
        ctaDisclaimer: 'No se requiere tarjeta de crédito',

        // Runway Gen-4.5
        runway45Title: 'Runway Gen-4.5',
        runway45Desc:
            'Fidelidad visual y control creativo sin precedentes, cinematográfico y altamente realista',

        // Relacionado con reproducción de video
        videoNotSupported: 'Su navegador no soporta reproducción de video',
        videoUnsupported: 'Su navegador no soporta reproducción de video',
        videoLoadingError: 'Error al cargar el video',
        videoLoadError: 'Error al cargar el video',
        videoReload: 'Recargar',
    },
    fr: {
        // Titre et description de la page
        pageTitle:
            'Générateur Vidéo Runway Gen-4 - Outil Professionnel de Création Vidéo',
        pageDescription:
            'Découvrez le générateur vidéo Runway Gen-4 avec des capacités de texte vers vidéo, image vers vidéo et édition vidéo intelligente. Créez des vidéos IA professionnelles gratuitement sur la plateforme 微鲤AI.',
        pageKeywords:
            'Runway Gen-4, Runway AI, générateur vidéo IA, texte vers vidéo, image vers vidéo, édition vidéo, vidéo IA gratuite, 微鲤AI, production vidéo',

        // Section du générateur
        generatorTitle: 'Générateur Vidéo Runway Gen-4',
        generatorDescription:
            "Runway Gen-4 et Gen-4 Turbo sont les derniers <span >modèles de génération vidéo IA</span> de Runway. S'appuyant sur le modèle précédent Gen-3 Alpha Turbo, cette nouvelle version améliore considérablement <span >l'adhérence aux prompts et le réalisme du mouvement</span>, ainsi que la <span >cohérence des personnages, du style et des objets</span> à travers les scènes. Découvrez Runway Gen-4 Turbo maintenant sur le <span >générateur vidéo 微鲤AI</span> !",

        // Onglets
        tabImageToVideo: 'Image vers Vidéo',
        tabTextToVideo: 'Texte vers Vidéo',

        // Section des fonctionnalités principales
        coreFeaturesTitle: 'Fonctionnalités Principales de Runway Gen-4',
        coreFeaturesSubtitle:
            'Explorez les fonctionnalités principales du générateur vidéo IA Runway Gen-4 et lancez-vous dans un voyage révolutionnaire de création vidéo IA',

        // Génération vidéo réaliste
        realisticVideoTitle: 'Génération Vidéo Réaliste',
        realisticVideoDescription:
            'Utilisez des images de référence simples pour générer des vidéos réalistes et riches en détails.',

        // Compréhension plus profonde des prompts
        deeperPromptTitle: 'Compréhension Plus Profonde des Prompts',
        deeperPromptDescription:
            'Suit les prompts complexes et détaillés avec une précision impeccable.',

        // Cohérence visuelle améliorée
        visualConsistencyTitle: 'Cohérence Visuelle Améliorée',
        visualConsistencyDescription:
            "Maintient la cohérence des personnages, objets et styles pour simuler la physique du monde réel dans n'importe quel environnement.",

        // Contrôle de caméra amélioré
        cameraControlTitle: 'Contrôle de Caméra Amélioré',
        cameraControlDescription:
            'Manipulez plus facilement plusieurs mouvements de sujets et perspectives de caméra dans une scène.',

        // Création vidéo plus rapide
        fasterVideoTitle: 'Création Vidéo Plus Rapide',
        fasterVideoDescription:
            'Grâce au modèle Gen-4 Turbo, la vitesse de génération augmente de 30 secondes pour chaque 10 secondes de vidéo.',

        // Section comment utiliser
        howToUseTitle: 'Comment Utiliser',
        howToUseSubtitle: 'Trois étapes simples pour commencer',
        step1Title: 'Sélectionner le Modèle Runway',
        step1Description:
            'Allez à la page <span >"Génération Vidéo IA"</span>, puis cliquez sur "Runway" dans le menu déroulant des modèles.',
        step2Title: 'Saisissez Votre Contenu Créatif',
        step2Description:
            'Décrivez ce que vous voulez générer, ou téléchargez des images pour la conversion, et sélectionnez votre configuration vidéo préférée.',
        step3Title: 'Téléchargez Votre Vidéo',
        step3Description:
            'Cliquez sur "Créer" pour télécharger ou partager librement votre vidéo générée.',

        // Section vidéos YouTube
        youtubeTitle: 'Vidéos YouTube sur le Modèle Runway Gen-4',
        youtubeVideosTitle: 'Vidéos YouTube sur le Modèle Runway Gen-4',
        youtubeVideoTitle: 'Vidéos YouTube sur le Modèle Runway Gen-4',

        // Section publications X
        xPostsTitle: 'Publications X Populaires sur le Modèle Runway Gen-4',

        // Section explorer d'autres modèles
        exploreModelsTitle: "Explorer d'Autres Modèles",
        sora2Title: 'Générateur Vidéo IA OpenAI Sora-2',
        veo3Title: 'Générateur Vidéo IA Google Veo 3.1',
        wanAITitle: 'Générateur Vidéo Wan AI',
        klingTitle: 'Générateur Vidéo kling 2.5',

        // Section FAQ
        faqTitle: 'Questions Fréquemment Posées',
        faq1Question: "Qu'est-ce que Runway AI ?",
        faq1Answer:
            'Runway AI est une plateforme leader de génération vidéo IA qui fournit plusieurs outils puissants de création vidéo tels que texte vers vidéo, image vers vidéo et édition vidéo intelligente, permettant aux créateurs de produire facilement du contenu vidéo de qualité professionnelle.',
        faq2Question:
            'Quelles sont les fonctionnalités principales de Runway AI ?',
        faq2Answer:
            "Les fonctionnalités principales de Runway AI incluent : texte vers vidéo, image vers vidéo, édition vidéo intelligente et suites d'outils créatifs. Il peut générer des vidéos basées sur des descriptions textuelles, convertir des images statiques en vidéos dynamiques et fournir de puissantes capacités d'édition vidéo.",
        faq3Question: 'Puis-je utiliser Runway AI gratuitement ?',
        faq3Answer:
            "Oui. Runway AI est disponible via l'essai gratuit de 微鲤AI avec des crédits gratuits limités. Pour une utilisation intensive, une mise à niveau sera nécessaire.",
        faq4Question: 'Quels formats vidéo Runway AI prend-il en charge ?',
        faq4Answer:
            'Runway AI prend en charge plusieurs formats vidéo principaux dont MP4, MOV, AVI, etc. Les vidéos générées sont de haute qualité, adaptées à divers usages, du partage sur les réseaux sociaux à la production vidéo professionnelle.',
        faq5Question:
            'Puis-je utiliser Runway AI pour des projets professionnels ou commerciaux ?',
        faq5Answer:
            "Oui. La génération vidéo de haute qualité et les fonctionnalités d'édition puissantes de Runway AI en font un choix solide pour les producteurs vidéo professionnels, les créateurs de contenu et les utilisateurs commerciaux.",

        // Section CTA
        ctaTitle: 'Prêt à Commencer à Créer ?',
        ctaSubtitle:
            'Découvrez Runway maintenant et transformez votre créativité en vidéos incroyables',
        ctaDescription:
            'Découvrez Runway maintenant et transformez votre créativité en vidéos incroyables',
        ctaButton: 'Essayez Runway sur 微鲤AI',
        ctaNote: 'Aucune carte de crédit requise',
        ctaDisclaimer: 'Aucune carte de crédit requise',

        // Runway Gen-4.5
        runway45Title: 'Runway Gen-4.5',
        runway45Desc:
            'Fidélité visuelle et contrôle créatif sans précédent, cinématographique et hautement réaliste',

        // Lié à la lecture vidéo
        videoNotSupported:
            'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoUnsupported:
            'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoLoadingError: 'Échec du chargement de la vidéo',
        videoLoadError: 'Échec du chargement de la vidéo',
        videoReload: 'Recharger',
    },
    de: {
        // Seitentitel und Beschreibung
        pageTitle:
            'Runway Gen-4 Video Generator - Professionelles Video-Erstellungstool',
        pageDescription:
            'Erleben Sie den Runway Gen-4 Video Generator mit Text-zu-Video-, Bild-zu-Video- und intelligenten Videobearbeitungsfunktionen. Erstellen Sie professionelle KI-Videos kostenlos auf der 微鲤AI-Plattform.',
        pageKeywords:
            'Runway Gen-4, Runway AI, KI-Video-Generator, Text zu Video, Bild zu Video, Videobearbeitung, kostenloses KI-Video, 微鲤AI, Videoproduktion',

        // Generator-Abschnitt
        generatorTitle: 'Runway Gen-4 Video Generator',
        generatorDescription:
            'Runway Gen-4 und Gen-4 Turbo sind Runways neueste <span >KI-Videogenerierungsmodelle</span>. Aufbauend auf dem vorherigen Gen-3 Alpha Turbo-Modell verbessert diese neue Version erheblich die <span >Prompt-Befolgung und Bewegungsrealismus</span> sowie die <span >Konsistenz von Charakteren, Stil und Objekten</span> über Szenen hinweg. Erleben Sie Runway Gen-4 Turbo jetzt auf dem <span >微鲤AI Video Generator</span>!',

        // Tabs
        tabImageToVideo: 'Bild zu Video',
        tabTextToVideo: 'Text zu Video',

        // Kernfunktionen-Abschnitt
        coreFeaturesTitle: 'Hauptfunktionen von Runway Gen-4',
        coreFeaturesSubtitle:
            'Erkunden Sie die Kernfunktionen des Runway Gen-4 KI-Videogenerators und begeben Sie sich auf eine revolutionäre KI-Videoerstellungsreise',

        // Realistische Videogenerierung
        realisticVideoTitle: 'Realistische Videogenerierung',
        realisticVideoDescription:
            'Verwenden Sie einfache Referenzbilder, um realistische und detailreiche Videos zu generieren.',

        // Tieferes Prompt-Verständnis
        deeperPromptTitle: 'Tieferes Prompt-Verständnis',
        deeperPromptDescription:
            'Folgt komplexen und detaillierten Prompts mit makelloser Genauigkeit.',

        // Verbesserte visuelle Konsistenz
        visualConsistencyTitle: 'Verbesserte Visuelle Konsistenz',
        visualConsistencyDescription:
            'Behält die Konsistenz von Charakteren, Objekten und Stilen bei, um die Physik der realen Welt in jeder Umgebung zu simulieren.',

        // Verbessertes Kamera-Kontrolle
        cameraControlTitle: 'Verbesserte Kamera-Kontrolle',
        cameraControlDescription:
            'Manipulieren Sie einfacher mehrere Subjektbewegungen und Kameraperspektiven in einer Szene.',

        // Schnellere Videoerstellung
        fasterVideoTitle: 'Schnellere Videoerstellung',
        fasterVideoDescription:
            'Durch das Gen-4 Turbo-Modell wird die Generierungsgeschwindigkeit um 30 Sekunden pro 10 Sekunden Video erhöht.',

        // Wie zu verwenden-Abschnitt
        howToUseTitle: 'Wie Man Verwendet',
        howToUseSubtitle: 'Drei einfache Schritte zum Einstieg',
        step1Title: 'Runway Modell Auswählen',
        step1Description:
            'Gehen Sie zur Seite <span >"KI-Videogenerierung"</span> und klicken Sie dann auf "Runway" im Modell-Dropdown-Menü.',
        step2Title: 'Geben Sie Ihren Kreativen Inhalt Ein',
        step2Description:
            'Beschreiben Sie, was Sie generieren möchten, oder laden Sie Bilder zur Konvertierung hoch und wählen Sie Ihre bevorzugte Videokonfiguration.',
        step3Title: 'Laden Sie Ihr Video Herunter',
        step3Description:
            'Klicken Sie auf "Erstellen", um Ihr generiertes Video frei herunterzuladen oder zu teilen.',

        // YouTube-Videos-Abschnitt
        youtubeTitle: 'YouTube-Videos über das Runway Gen-4 Modell',
        youtubeVideosTitle: 'YouTube-Videos über das Runway Gen-4 Modell',
        youtubeVideoTitle: 'YouTube-Videos über das Runway Gen-4 Modell',

        // X-Beiträge-Abschnitt
        xPostsTitle: 'Beliebte X-Beiträge über das Runway Gen-4 Modell',

        // Andere Modelle erkunden-Abschnitt
        exploreModelsTitle: 'Andere Modelle Erkunden',
        sora2Title: 'OpenAI Sora-2 KI-Videogenerator',
        veo3Title: 'Google Veo 3.1 KI-Videogenerator',
        wanAITitle: 'Wan AI Videogenerator',
        klingTitle: 'kling 2.5 Videogenerator',

        // FAQ-Abschnitt
        faqTitle: 'Häufig Gestellte Fragen',
        faq1Question: 'Was ist Runway AI?',
        faq1Answer:
            'Runway AI ist eine führende KI-Videogenerierungsplattform, die mehrere leistungsstarke Videoerstellungstools wie Text-zu-Video, Bild-zu-Video und intelligente Videobearbeitung bereitstellt, die es Kreativen ermöglichen, professionelle Videoinhalte einfach zu produzieren.',
        faq2Question: 'Was sind die Hauptfunktionen von Runway AI?',
        faq2Answer:
            'Die Hauptfunktionen von Runway AI umfassen: Text-zu-Video, Bild-zu-Video, intelligente Videobearbeitung und kreative Tool-Suites. Es kann Videos basierend auf Textbeschreibungen generieren, statische Bilder in dynamische Videos konvertieren und leistungsstarke Videobearbeitungsfunktionen bereitstellen.',
        faq3Question: 'Kann ich Runway AI kostenlos verwenden?',
        faq3Answer:
            'Ja. Runway AI ist über die kostenlose Testversion von 微鲤AI mit begrenzten kostenlosen Credits verfügbar. Für intensive Nutzung ist ein Upgrade erforderlich.',
        faq4Question: 'Welche Videoformate unterstützt Runway AI?',
        faq4Answer:
            'Runway AI unterstützt mehrere gängige Videoformate einschließlich MP4, MOV, AVI usw. Generierte Videos sind von hoher Qualität und für verschiedene Zwecke geeignet, vom Teilen in sozialen Medien bis zur professionellen Videoproduktion.',
        faq5Question:
            'Kann ich Runway AI für professionelle oder kommerzielle Projekte verwenden?',
        faq5Answer:
            'Ja. Runway AIs hochwertige Videogenerierung und leistungsstarke Bearbeitungsfunktionen machen es zu einer soliden Wahl für professionelle Videoproduzenten, Content-Ersteller und kommerzielle Benutzer.',

        // CTA-Abschnitt
        ctaTitle: 'Bereit zum Erstellen?',
        ctaSubtitle:
            'Erleben Sie Runway jetzt und verwandeln Sie Ihre Kreativität in erstaunliche Videos',
        ctaDescription:
            'Erleben Sie Runway jetzt und verwandeln Sie Ihre Kreativität in erstaunliche Videos',
        ctaButton: 'Testen Sie Runway auf 微鲤AI',
        ctaNote: 'Keine Kreditkarte erforderlich',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich',

        // Runway Gen-4.5
        runway45Title: 'Runway Gen-4',
        runway45Desc:
            'Beispiellose visuelle Wiedergabetreue und kreative Kontrolle, kinoreif und hochrealistisch',

        // Videowiedergabe-bezogen
        videoNotSupported: 'Ihr Browser unterstützt keine Videowiedergabe',
        videoUnsupported: 'Ihr Browser unterstützt keine Videowiedergabe',
        videoLoadingError: 'Videoladen fehlgeschlagen',
        videoLoadError: 'Videoladen fehlgeschlagen',
        videoReload: 'Neu laden',
    },
    ru: {
        // Заголовок и описание страницы
        pageTitle:
            'Генератор Видео Runway Gen-4 - Профессиональный Инструмент Создания Видео',
        pageDescription:
            'Испытайте генератор видео Runway Gen-4 с возможностями текст в видео, изображение в видео и интеллектуального редактирования видео. Создавайте профессиональные ИИ-видео бесплатно на платформе 微鲤AI.',
        pageKeywords:
            'Runway Gen-4, Runway AI, генератор видео ИИ, текст в видео, изображение в видео, редактирование видео, бесплатное ИИ-видео, 微鲤AI, производство видео',

        // Раздел генератора
        generatorTitle: 'Генератор Видео Runway Gen-4',
        generatorDescription:
            'Runway Gen-4 и Gen-4 Turbo - это новейшие <span >модели генерации видео с ИИ</span> от Runway. Основываясь на предыдущей модели Gen-3 Alpha Turbo, эта новая версия значительно улучшает <span >следование промптам и реализм движения</span>, а также <span >согласованность персонажей, стиля и объектов</span> между сценами. Испытайте Runway Gen-4 Turbo прямо сейчас на <span >генераторе видео 微鲤AI</span>!',

        // Вкладки
        tabImageToVideo: 'Изображение в видео',
        tabTextToVideo: 'Текст в видео',

        // Раздел основных функций
        coreFeaturesTitle: 'Основные функции Runway Gen-4',
        coreFeaturesSubtitle:
            'Изучите основные функции генератора видео Runway Gen-4 AI и отправьтесь в революционное путешествие по созданию видео с ИИ',

        // Реалистичная генерация видео
        realisticVideoTitle: 'Реалистичная генерация видео',
        realisticVideoDescription:
            'Используйте простые референсные изображения для генерации реалистичных и детализированных видео.',

        // Более глубокое понимание промптов
        deeperPromptTitle: 'Более глубокое понимание промптов',
        deeperPromptDescription:
            'Следует сложным и детальным промптам с безупречной точностью.',

        // Улучшенная визуальная согласованность
        visualConsistencyTitle: 'Улучшенная визуальная согласованность',
        visualConsistencyDescription:
            'Поддерживает согласованность персонажей, объектов и стилей для симуляции физики реального мира в любой среде.',

        // Улучшенное управление камерой
        cameraControlTitle: 'Улучшенное управление камерой',
        cameraControlDescription:
            'Легче манипулируйте множественными движениями субъектов и перспективами камеры в сцене.',

        // Более быстрое создание видео
        fasterVideoTitle: 'Более быстрое создание видео',
        fasterVideoDescription:
            'Благодаря модели Gen-4 Turbo скорость генерации увеличивается на 30 секунд на каждые 10 секунд видео.',

        // Раздел как использовать
        howToUseTitle: 'Как использовать',
        howToUseSubtitle: 'Три простых шага для начала',
        step1Title: 'Выберите модель Runway',
        step1Description:
            'Перейдите на страницу <span >"Генерация видео с ИИ"</span>, затем нажмите "Runway" в выпадающем меню моделей.',
        step2Title: 'Введите ваш творческий контент',
        step2Description:
            'Опишите, что вы хотите сгенерировать, или загрузите изображения для конверсии и выберите предпочитаемую конфигурацию видео.',
        step3Title: 'Скачайте ваше видео',
        step3Description:
            'Нажмите "Создать", чтобы свободно скачать или поделиться сгенерированным видео.',

        // Раздел видео на YouTube
        youtubeTitle: 'Видео на YouTube о модели Runway Gen-4',
        youtubeVideosTitle: 'Видео на YouTube о модели Runway Gen-4',
        youtubeVideoTitle: 'Видео на YouTube о модели Runway Gen-4',

        // Раздел постов X
        xPostsTitle: 'Популярные посты X о модели Runway Gen-4',

        // Раздел исследования других моделей
        exploreModelsTitle: 'Исследовать другие модели',
        sora2Title: 'Генератор видео ИИ OpenAI Sora-2',
        veo3Title: 'Генератор видео ИИ Google Veo 3.1',
        wanAITitle: 'Генератор видео Wan AI',
        klingTitle: 'Генератор видео kling 2.5',

        // Раздел FAQ
        faqTitle: 'Часто задаваемые вопросы',
        faq1Question: 'Что такое Runway AI?',
        faq1Answer:
            'Runway AI - это ведущая платформа генерации видео с ИИ, которая предоставляет множество мощных инструментов создания видео, таких как текст в видео, изображение в видео и интеллектуальное редактирование видео, позволяя создателям легко производить видеоконтент профессионального уровня.',
        faq2Question: 'Каковы основные функции Runway AI?',
        faq2Answer:
            'Основные функции Runway AI включают: текст в видео, изображение в видео, интеллектуальное редактирование видео и наборы творческих инструментов. Он может генерировать видео на основе текстовых описаний, преобразовывать статические изображения в динамические видео и предоставлять мощные возможности редактирования видео.',
        faq3Question: 'Могу ли я использовать Runway AI бесплатно?',
        faq3Answer:
            'Да. Runway AI доступен через бесплатную пробную версию 微鲤AI с ограниченными бесплатными кредитами. Для интенсивного использования потребуется обновление.',
        faq4Question: 'Какие форматы видео поддерживает Runway AI?',
        faq4Answer:
            'Runway AI поддерживает несколько основных видеоформатов, включая MP4, MOV, AVI и т.д. Сгенерированные видео высокого качества, подходящие для различных целей, от обмена в социальных сетях до профессионального производства видео.',
        faq5Question:
            'Могу ли я использовать Runway AI для профессиональных или коммерческих проектов?',
        faq5Answer:
            'Да. Высококачественная генерация видео и мощные функции редактирования Runway AI делают его надежным выбором для профессиональных видеопродюсеров, создателей контента и коммерческих пользователей.',

        // Раздел CTA
        ctaTitle: 'Готовы начать создавать?',
        ctaSubtitle:
            'Испытайте Runway сейчас и превратите вашу креативность в потрясающие видео',
        ctaDescription:
            'Испытайте Runway сейчас и превратите вашу креативность в потрясающие видео',
        ctaButton: 'Попробуйте Runway на 微鲤AI',
        ctaNote: 'Кредитная карта не требуется',
        ctaDisclaimer: 'Кредитная карта не требуется',

        // Runway Gen-4.5
        runway45Title: 'Runway Gen-4.5',
        runway45Desc:
            'Беспрецедентная визуальная точность и творческий контроль, кинематографичный и высокореалистичный',

        // Связанное с воспроизведением видео
        videoNotSupported: 'Ваш браузер не поддерживает воспроизведение видео',
        videoUnsupported: 'Ваш браузер не поддерживает воспроизведение видео',
        videoLoadingError: 'Ошибка загрузки видео',
        videoLoadError: 'Ошибка загрузки видео',
        videoReload: 'Перезагрузить',
    },
    pt: {
        // Título e descrição da página
        pageTitle:
            'Gerador de Vídeo Runway Gen-4 - Ferramenta Profissional de Criação de Vídeo',
        pageDescription:
            'Experimente o gerador de vídeo Runway Gen-4 com capacidades de texto para vídeo, imagem para vídeo e edição inteligente de vídeo. Crie vídeos IA profissionais grátis na plataforma 微鲤AI.',
        pageKeywords:
            'Runway Gen-4, Runway AI, gerador de vídeo IA, texto para vídeo, imagem para vídeo, edição de vídeo, vídeo IA grátis, 微鲤AI, produção de vídeo',

        // Seção do gerador
        generatorTitle: 'Gerador de Vídeo Runway Gen-4',
        generatorDescription:
            'Runway Gen-4 e Gen-4 Turbo são os mais recentes <span >modelos de geração de vídeo IA</span> da Runway. Baseando-se no modelo anterior Gen-3 Alpha Turbo, esta nova versão melhora significativamente <span >a aderência a prompts e o realismo do movimento</span>, bem como a <span >consistência de personagens, estilo e objetos</span> através de cenas. Experimente Runway Gen-4 Turbo agora no <span >gerador de vídeo 微鲤AI</span>!',

        // Abas
        tabImageToVideo: 'Imagem para Vídeo',
        tabTextToVideo: 'Texto para Vídeo',

        // Seção de recursos principais
        coreFeaturesTitle: 'Recursos Principais do Runway Gen-4',
        coreFeaturesSubtitle:
            'Explore os recursos principais do gerador de vídeo IA Runway Gen-4 e embarque em uma jornada revolucionária de criação de vídeo IA',

        // Geração de vídeo realista
        realisticVideoTitle: 'Geração de Vídeo Realista',
        realisticVideoDescription:
            'Use imagens de referência simples para gerar vídeos realistas e ricos em detalhes.',

        // Compreensão mais profunda de prompts
        deeperPromptTitle: 'Compreensão Mais Profunda de Prompts',
        deeperPromptDescription:
            'Segue prompts complexos e detalhados com precisão impecável.',

        // Consistência visual melhorada
        visualConsistencyTitle: 'Consistência Visual Melhorada',
        visualConsistencyDescription:
            'Mantém a consistência de personagens, objetos e estilos para simular a física do mundo real em qualquer ambiente.',

        // Controle de câmera aprimorado
        cameraControlTitle: 'Controle de Câmera Aprimorado',
        cameraControlDescription:
            'Manipule mais facilmente múltiplos movimentos de sujeitos e perspectivas de câmera em uma cena.',

        // Criação de vídeo mais rápida
        fasterVideoTitle: 'Criação de Vídeo Mais Rápida',
        fasterVideoDescription:
            'Através do modelo Gen-4 Turbo, a velocidade de geração aumenta 30 segundos para cada 10 segundos de vídeo.',

        // Seção como usar
        howToUseTitle: 'Como Usar',
        howToUseSubtitle: 'Três passos simples para começar',
        step1Title: 'Selecionar Modelo Runway',
        step1Description:
            'Vá para a página <span >"Geração de Vídeo IA"</span>, depois clique em "Runway" no menu suspenso de modelos.',
        step2Title: 'Insira Seu Conteúdo Criativo',
        step2Description:
            'Descreva o que deseja gerar, ou faça upload de imagens para conversão, e selecione sua configuração de vídeo preferida.',
        step3Title: 'Baixe Seu Vídeo',
        step3Description:
            'Clique em "Criar" para baixar ou compartilhar livremente seu vídeo gerado.',

        // Seção de vídeos do YouTube
        youtubeTitle: 'Vídeos do YouTube sobre o Modelo Runway Gen-4',
        youtubeVideosTitle: 'Vídeos do YouTube sobre o Modelo Runway Gen-4',
        youtubeVideoTitle: 'Vídeos do YouTube sobre o Modelo Runway Gen-4',

        // Seção de publicações X
        xPostsTitle: 'Publicações Populares do X sobre o Modelo Runway Gen-4',

        // Seção explorar outros modelos
        exploreModelsTitle: 'Explorar Outros Modelos',
        sora2Title: 'Gerador de Vídeo IA OpenAI Sora-2',
        veo3Title: 'Gerador de Vídeo IA Google Veo 3.1',
        wanAITitle: 'Gerador de Vídeo Wan AI',
        klingTitle: 'Gerador de Vídeo kling 2.5',

        // Seção FAQ
        faqTitle: 'Perguntas Frequentes',
        faq1Question: 'O que é Runway AI?',
        faq1Answer:
            'Runway AI é uma plataforma líder de geração de vídeo IA que fornece múltiplas ferramentas poderosas de criação de vídeo, como texto para vídeo, imagem para vídeo e edição inteligente de vídeo, permitindo que criadores produzam facilmente conteúdo de vídeo de nível profissional.',
        faq2Question: 'Quais são os recursos principais do Runway AI?',
        faq2Answer:
            'Os recursos principais do Runway AI incluem: texto para vídeo, imagem para vídeo, edição inteligente de vídeo e conjuntos de ferramentas criativas. Pode gerar vídeos baseados em descrições de texto, converter imagens estáticas em vídeos dinâmicos e fornecer capacidades poderosas de edição de vídeo.',
        faq3Question: 'Posso usar o Runway AI gratuitamente?',
        faq3Answer:
            'Sim. Runway AI está disponível através do teste gratuito do 微鲤AI com créditos gratuitos limitados. Para uso intensivo, será necessária uma atualização.',
        faq4Question: 'Quais formatos de vídeo o Runway AI suporta?',
        faq4Answer:
            'Runway AI suporta múltiplos formatos de vídeo principais incluindo MP4, MOV, AVI, etc. Os vídeos gerados são de alta qualidade, adequados para diversos propósitos, desde compartilhamento em redes sociais até produção profissional de vídeo.',
        faq5Question:
            'Posso usar o Runway AI para projetos profissionais ou comerciais?',
        faq5Answer:
            'Sim. A geração de vídeo de alta qualidade e os recursos de edição poderosos do Runway AI o tornam uma escolha sólida para produtores de vídeo profissionais, criadores de conteúdo e usuários comerciais.',

        // Seção CTA
        ctaTitle: 'Pronto para Começar a Criar?',
        ctaSubtitle:
            'Experimente o Runway agora e transforme sua criatividade em vídeos incríveis',
        ctaDescription:
            'Experimente o Runway agora e transforme sua criatividade em vídeos incríveis',
        ctaButton: 'Experimente o Runway no 微鲤AI',
        ctaNote: 'Não é necessário cartão de crédito',
        ctaDisclaimer: 'Não é necessário cartão de crédito',

        // Runway Gen-4.5
        runway45Title: 'Runway Gen-4.5',
        runway45Desc:
            'Fidelidade visual e controle criativo sem precedentes, cinematográfico e altamente realista',

        // Relacionado à reprodução de vídeo
        videoNotSupported: 'Seu navegador não suporta reprodução de vídeo',
        videoUnsupported: 'Seu navegador não suporta reprodução de vídeo',
        videoLoadingError: 'Falha ao carregar o vídeo',
        videoLoadError: 'Falha ao carregar o vídeo',
        videoReload: 'Recarregar',
    },
    it: {
        // Titolo e descrizione della pagina
        pageTitle:
            'Generatore Video Runway Gen-4 - Strumento Professionale di Creazione Video',
        pageDescription:
            'Sperimenta il generatore video Runway Gen-4 con capacità di testo a video, immagine a video e modifica intelligente di video. Crea video IA professionali gratis sulla piattaforma 微鲤AI.',
        pageKeywords:
            'Runway Gen-4, Runway AI, generatore video IA, testo a video, immagine a video, modifica video, video IA gratuito, 微鲤AI, produzione video',

        // Sezione generatore
        generatorTitle: 'Generatore Video Runway Gen-4',
        generatorDescription:
            "Runway Gen-4 e Gen-4 Turbo sono gli ultimi <span >modelli di generazione video IA</span> di Runway. Basandosi sul modello precedente Gen-3 Alpha Turbo, questa nuova versione migliora significativamente <span >l'aderenza ai prompt e il realismo del movimento</span>, così come la <span >coerenza di personaggi, stile e oggetti</span> attraverso le scene. Prova Runway Gen-4 Turbo ora sul <span >generatore video 微鲤AI</span>!",

        // Schede
        tabImageToVideo: 'Immagine a Video',
        tabTextToVideo: 'Testo a Video',

        // Sezione caratteristiche principali
        coreFeaturesTitle: 'Caratteristiche Principali di Runway Gen-4',
        coreFeaturesSubtitle:
            'Esplora le caratteristiche principali del generatore video IA Runway Gen-4 e intraprendi un viaggio rivoluzionario nella creazione di video IA',

        // Generazione video realistica
        realisticVideoTitle: 'Generazione Video Realistica',
        realisticVideoDescription:
            'Usa immagini di riferimento semplici per generare video realistici e ricchi di dettagli.',

        // Comprensione più profonda dei prompt
        deeperPromptTitle: 'Comprensione Più Profonda dei Prompt',
        deeperPromptDescription:
            'Segue prompt complessi e dettagliati con precisione impeccabile.',

        // Coerenza visiva migliorata
        visualConsistencyTitle: 'Coerenza Visiva Migliorata',
        visualConsistencyDescription:
            'Mantiene la coerenza di personaggi, oggetti e stili per simulare la fisica del mondo reale in qualsiasi ambiente.',

        // Controllo della fotocamera migliorato
        cameraControlTitle: 'Controllo della Fotocamera Migliorato',
        cameraControlDescription:
            'Manipola più facilmente più movimenti di soggetti e prospettive della fotocamera in una scena.',

        // Creazione video più veloce
        fasterVideoTitle: 'Creazione Video Più Veloce',
        fasterVideoDescription:
            'Attraverso il modello Gen-4 Turbo, la velocità di generazione aumenta di 30 secondi per ogni 10 secondi di video.',

        // Sezione come usare
        howToUseTitle: 'Come Usare',
        howToUseSubtitle: 'Tre semplici passaggi per iniziare',
        step1Title: 'Seleziona Modello Runway',
        step1Description:
            'Vai alla pagina <span >"Generazione Video IA"</span>, quindi clicca su "Runway" nel menu a discesa dei modelli.',
        step2Title: 'Inserisci il Tuo Contenuto Creativo',
        step2Description:
            'Descrivi cosa vuoi generare, o carica immagini per la conversione, e seleziona la tua configurazione video preferita.',
        step3Title: 'Scarica il Tuo Video',
        step3Description:
            'Clicca su "Crea" per scaricare o condividere liberamente il tuo video generato.',

        // Sezione video YouTube
        youtubeTitle: 'Video YouTube sul Modello Runway Gen-4',
        youtubeVideosTitle: 'Video YouTube sul Modello Runway Gen-4',
        youtubeVideoTitle: 'Video YouTube sul Modello Runway Gen-4',

        // Sezione post X
        xPostsTitle: 'Post X Popolari sul Modello Runway Gen-4',

        // Sezione esplora altri modelli
        exploreModelsTitle: 'Esplora Altri Modelli',
        sora2Title: 'Generatore Video IA OpenAI Sora-2',
        veo3Title: 'Generatore Video IA Google Veo 3.1',
        wanAITitle: 'Generatore Video Wan AI',
        klingTitle: 'Generatore Video kling 2.5',

        // Sezione FAQ
        faqTitle: 'Domande Frequenti',
        faq1Question: "Cos'è Runway AI?",
        faq1Answer:
            'Runway AI è una piattaforma leader di generazione video IA che fornisce molteplici potenti strumenti di creazione video come testo a video, immagine a video e modifica intelligente di video, consentendo ai creatori di produrre facilmente contenuti video di livello professionale.',
        faq2Question: 'Quali sono le caratteristiche principali di Runway AI?',
        faq2Answer:
            'Le caratteristiche principali di Runway AI includono: testo a video, immagine a video, modifica intelligente di video e suite di strumenti creativi. Può generare video basati su descrizioni testuali, convertire immagini statiche in video dinamici e fornire potenti capacità di modifica video.',
        faq3Question: 'Posso usare Runway AI gratuitamente?',
        faq3Answer:
            'Sì. Runway AI è disponibile tramite la prova gratuita di 微鲤AI con crediti gratuiti limitati. Per un uso intensivo, sarà necessario un upgrade.',
        faq4Question: 'Quali formati video supporta Runway AI?',
        faq4Answer:
            'Runway AI supporta più formati video principali tra cui MP4, MOV, AVI, ecc. I video generati sono di alta qualità, adatti a vari scopi, dalla condivisione sui social media alla produzione video professionale.',
        faq5Question:
            'Posso usare Runway AI per progetti professionali o commerciali?',
        faq5Answer:
            'Sì. La generazione video di alta qualità e le potenti funzionalità di modifica di Runway AI lo rendono una scelta solida per produttori video professionali, creatori di contenuti e utenti commerciali.',

        // Sezione CTA
        ctaTitle: 'Pronto per Iniziare a Creare?',
        ctaSubtitle:
            'Prova Runway ora e trasforma la tua creatività in video straordinari',
        ctaDescription:
            'Prova Runway ora e trasforma la tua creatività in video straordinari',
        ctaButton: 'Prova Runway su 微鲤AI',
        ctaNote: 'Non è richiesta la carta di credito',
        ctaDisclaimer: 'Non è richiesta la carta di credito',

        // Runway Gen-4.5
        runway45Title: 'Runway Gen-4.5',
        runway45Desc:
            'Fedeltà visiva e controllo creativo senza precedenti, cinematografico e altamente realistico',

        // Relativo alla riproduzione video
        videoNotSupported: 'Il tuo browser non supporta la riproduzione video',
        videoUnsupported: 'Il tuo browser non supporta la riproduzione video',
        videoLoadingError: 'Caricamento video fallito',
        videoLoadError: 'Caricamento video fallito',
        videoReload: 'Ricarica',
    },
    ar: {
        // عنوان ووصف الصفحة
        pageTitle: 'مولد فيديو Runway Gen-4 - أداة إنشاء فيديو احترافية',
        pageDescription:
            'جرب مولد فيديو Runway Gen-4 مع إمكانيات النص إلى فيديو والصورة إلى فيديو والتحرير الذكي للفيديو. أنشئ مقاطع فيديو ذكاء اصطناعي احترافية مجانًا على منصة 微鲤AI.',
        pageKeywords:
            'Runway Gen-4, Runway AI, مولد فيديو بالذكاء الاصطناعي, نص إلى فيديو, صورة إلى فيديو, تحرير الفيديو, فيديو ذكاء اصطناعي مجاني, 微鲤AI, إنتاج الفيديو',

        // قسم المولد
        generatorTitle: 'مولد الفيديو Runway Gen-4',
        generatorDescription:
            'Runway Gen-4 وGen-4 Turbo هما أحدث <span >نماذج توليد الفيديو بالذكاء الاصطناعي</span> من Runway. بناءً على نموذج Gen-3 Alpha Turbo السابق، تعمل هذه النسخة الجديدة على تحسين <span >الالتزام بالمطالبات وواقعية الحركة</span> بشكل كبير، بالإضافة إلى <span >اتساق الشخصيات والأسلوب والكائنات</span> عبر المشاهد. جرب Runway Gen-4 Turbo الآن على <span >مولد الفيديو 微鲤AI</span>!',

        // التبويبات
        tabImageToVideo: 'صورة إلى فيديو',
        tabTextToVideo: 'نص إلى فيديو',

        // قسم الميزات الأساسية
        coreFeaturesTitle: 'الميزات الرئيسية لـ Runway Gen-4',
        coreFeaturesSubtitle:
            'استكشف الميزات الأساسية لمولد الفيديو بالذكاء الاصطناعي Runway Gen-4 وابدأ رحلة ثورية لإنشاء فيديو بالذكاء الاصطناعي',

        // توليد فيديو واقعي
        realisticVideoTitle: 'توليد فيديو واقعي',
        realisticVideoDescription:
            'استخدم صور مرجعية بسيطة لتوليد مقاطع فيديو واقعية وغنية بالتفاصيل.',

        // فهم أعمق للمطالبات
        deeperPromptTitle: 'فهم أعمق للمطالبات',
        deeperPromptDescription:
            'يتبع المطالبات المعقدة والمفصلة بدقة لا تشوبها شائبة.',

        // اتساق بصري محسن
        visualConsistencyTitle: 'اتساق بصري محسن',
        visualConsistencyDescription:
            'يحافظ على اتساق الشخصيات والكائنات والأنماط لمحاكاة فيزياء العالم الحقيقي في أي بيئة.',

        // تحكم محسن في الكاميرا
        cameraControlTitle: 'تحكم محسن في الكاميرا',
        cameraControlDescription:
            'تحكم بسهولة أكبر في حركات عدة أشخاص ووجهات نظر الكاميرا في المشهد.',

        // إنشاء فيديو أسرع
        fasterVideoTitle: 'إنشاء فيديو أسرع',
        fasterVideoDescription:
            'من خلال نموذج Gen-4 Turbo، تزيد سرعة التوليد بمقدار 30 ثانية لكل 10 ثوانٍ من الفيديو.',

        // قسم كيفية الاستخدام
        howToUseTitle: 'كيفية الاستخدام',
        howToUseSubtitle: 'ثلاث خطوات بسيطة للبدء',
        step1Title: 'اختر نموذج Runway',
        step1Description:
            'انتقل إلى صفحة <span >"توليد الفيديو بالذكاء الاصطناعي"</span>، ثم انقر على "Runway" في القائمة المنسدلة للنماذج.',
        step2Title: 'أدخل محتواك الإبداعي',
        step2Description:
            'صف ما تريد توليده، أو قم بتحميل صور للتحويل، واختر تكوين الفيديو المفضل لديك.',
        step3Title: 'قم بتنزيل الفيديو الخاص بك',
        step3Description:
            'انقر على "إنشاء" لتنزيل أو مشاركة الفيديو المُنشأ بحرية.',

        // قسم فيديوهات YouTube
        youtubeTitle: 'فيديوهات YouTube حول نموذج Runway Gen-4',
        youtubeVideosTitle: 'فيديوهات YouTube حول نموذج Runway Gen-4',
        youtubeVideoTitle: 'فيديوهات YouTube حول نموذج Runway Gen-4',

        // قسم منشورات X
        xPostsTitle: 'منشورات X الشائعة حول نموذج Runway Gen-4',

        // قسم استكشاف نماذج أخرى
        exploreModelsTitle: 'استكشف نماذج أخرى',
        sora2Title: 'مولد الفيديو بالذكاء الاصطناعي OpenAI Sora-2',
        veo3Title: 'مولد الفيديو بالذكاء الاصطناعي Google Veo 3.1',
        wanAITitle: 'مولد الفيديو Wan AI',
        klingTitle: 'مولد الفيديو kling 2.5',

        // قسم الأسئلة الشائعة
        faqTitle: 'الأسئلة الشائعة',
        faq1Question: 'ما هو Runway AI؟',
        faq1Answer:
            'Runway AI هي منصة رائدة لتوليد الفيديو بالذكاء الاصطناعي توفر أدوات إنشاء فيديو قوية متعددة مثل النص إلى فيديو والصورة إلى فيديو والتحرير الذكي للفيديو، مما يسمح للمبدعين بإنتاج محتوى فيديو بمستوى احترافي بسهولة.',
        faq2Question: 'ما هي الميزات الرئيسية لـ Runway AI؟',
        faq2Answer:
            'تشمل الميزات الرئيسية لـ Runway AI: النص إلى فيديو، الصورة إلى فيديو، التحرير الذكي للفيديو ومجموعات الأدوات الإبداعية. يمكنه توليد مقاطع فيديو بناءً على أوصاف نصية، وتحويل الصور الثابتة إلى مقاطع فيديو ديناميكية، وتوفير قدرات تحرير فيديو قوية.',
        faq3Question: 'هل يمكنني استخدام Runway AI مجانًا؟',
        faq3Answer:
            'نعم. Runway AI متاح من خلال الإصدار التجريبي المجاني من 微鲤AI مع أرصدة مجانية محدودة. للاستخدام المكثف، ستكون هناك حاجة إلى ترقية.',
        faq4Question: 'ما تنسيقات الفيديو التي يدعمها Runway AI؟',
        faq4Answer:
            'يدعم Runway AI تنسيقات فيديو رئيسية متعددة بما في ذلك MP4 وMOV وAVI وغيرها. مقاطع الفيديو المُنشأة عالية الجودة، ومناسبة لأغراض مختلفة من المشاركة على وسائل التواصل الاجتماعي إلى الإنتاج الاحترافي للفيديو.',
        faq5Question:
            'هل يمكنني استخدام Runway AI للمشاريع الاحترافية أو التجارية؟',
        faq5Answer:
            'نعم. تجعل توليد الفيديو عالي الجودة وميزات التحرير القوية لـ Runway AI خيارًا قويًا لمنتجي الفيديو المحترفين ومنشئي المحتوى والمستخدمين التجاريين.',

        // قسم CTA
        ctaTitle: 'هل أنت مستعد للبدء في الإنشاء؟',
        ctaSubtitle: 'جرب Runway الآن وحوّل إبداعك إلى مقاطع فيديو مذهلة',
        ctaDescription: 'جرب Runway الآن وحوّل إبداعك إلى مقاطع فيديو مذهلة',
        ctaButton: 'جرب Runway على 微鲤AI',
        ctaNote: 'لا حاجة لبطاقة ائتمان',
        ctaDisclaimer: 'لا حاجة لبطاقة ائتمان',

        // Runway Gen-4.5
        runway45Title: 'Runway Gen-4.5',
        runway45Desc: 'دقة بصرية وتحكم إبداعي غير مسبوق، سينمائي وواقعي للغاية',

        // متعلق بتشغيل الفيديو
        videoNotSupported: 'متصفحك لا يدعم تشغيل الفيديو',
        videoUnsupported: 'متصفحك لا يدعم تشغيل الفيديو',
        videoLoadingError: 'فشل تحميل الفيديو',
        videoLoadError: 'فشل تحميل الفيديو',
        videoReload: 'إعادة التحميل',
        },
    th: {
        // Page title and description
        pageTitle:
            'Runway Gen-4 ตัวสร้างวิดีโอ - เครื่องมือสร้างวิดีโอระดับมืออาชีพ',
        pageDescription:
            'สัมผัส Runway Gen-4 พร้อมความสามารถข้อความเป็นวิดีโอ ภาพเป็นวิดีโอ และการตัดต่อวิดีโออัจฉริยะ สร้างวิดีโอ AI ระดับมืออาชีพได้ฟรีบน 微鲤AI',
        pageKeywords:
            'Runway Gen-4, Runway AI, ตัวสร้างวิดีโอ AI, ข้อความเป็นวิดีโอ, ภาพเป็นวิดีโอ, ตัดต่อวิดีโอ, วิดีโอ AI ฟรี, 微鲤AI, การผลิตวิดีโอ',

        // Generator section
        generatorTitle: 'เครื่องมือสร้างวิดีโอ Runway Gen-4',
        generatorDescription:
            'Runway Gen-4 และ Gen-4 Turbo คือ <span >โมเดลสร้างวิดีโอ AI ล่าสุดของ Runway</span> ที่ต่อยอดจาก Gen-3 Alpha Turbo โดยเวอร์ชันใหม่นี้ปรับปรุงอย่างมากทั้ง <span >การยึดตามพรอมป์ต์และความสมจริงของการเคลื่อนไหว</span> รวมถึง <span >ความสม่ำเสมอของตัวละคร สไตล์ และวัตถุ</span> ระหว่างฉาก ลองใช้ Runway Gen-4 Turbo ได้แล้วบน <span >ตัวสร้างวิดีโอ 微鲤AI</span>!',

        // Tabs
        tabImageToVideo: 'ภาพเป็นวิดีโอ',
        tabTextToVideo: 'ข้อความเป็นวิดีโอ',

        // Core features section
        coreFeaturesTitle: 'ฟีเจอร์หลักของ Runway Gen-4',
        coreFeaturesSubtitle:
            'สำรวจฟีเจอร์หลักของตัวสร้างวิดีโอ AI Runway Gen-4 และเริ่มต้นการสร้างวิดีโอ AI แบบปฏิวัติ',

        // Realistic video generation
        realisticVideoTitle: 'การสร้างวิดีโอสมจริง',
        realisticVideoDescription:
            'ใช้ภาพอ้างอิงง่ายๆ เพื่อสร้างวิดีโอที่สมจริงและมีรายละเอียดสูง',

        // Deeper prompt understanding
        deeperPromptTitle: 'เข้าใจพรอมป์ต์เชิงลึกยิ่งขึ้น',
        deeperPromptDescription:
            'ทำตามพรอมป์ต์ที่ซับซ้อนและละเอียดได้อย่างแม่นยำ',

        // Improved visual consistency
        visualConsistencyTitle: 'ความสม่ำเสมอของภาพที่ดีขึ้น',
        visualConsistencyDescription:
            'รักษาความสม่ำเสมอของตัวละคร วัตถุ และสไตล์ เพื่อจำลองฟิสิกส์ของโลกจริงในทุกสภาพแวดล้อม',

        // Enhanced camera control
        cameraControlTitle: 'ควบคุมกล้องได้ดีขึ้น',
        cameraControlDescription:
            'จัดการการเคลื่อนไหวของหลายวัตถุและมุมกล้องในฉากได้ง่ายกว่าเดิม',

        // Faster video creation
        fasterVideoTitle: 'สร้างวิดีโอได้เร็วขึ้น',
        fasterVideoDescription:
            'ด้วยโมเดล Gen-4 Turbo ความเร็วในการสร้างเพิ่มขึ้น 30 วินาทีต่อวิดีโอ 10 วินาที',

        // How to use section
        howToUseTitle: 'วิธีใช้งาน',
        howToUseSubtitle: 'เริ่มต้นได้ง่ายใน 3 ขั้นตอน',
        step1Title: 'เลือกโมเดล Runway',
        step1Description:
            'ไปที่หน้า <span >"AI Video Generation"</span> แล้วคลิก "Runway" ในเมนูดรอปดาวน์โมเดล',
        step2Title: 'ใส่คอนเทนต์สร้างสรรค์ของคุณ',
        step2Description:
            'อธิบายสิ่งที่ต้องการสร้าง หรืออัปโหลดภาพเพื่อแปลง และเลือกการตั้งค่าวิดีโอที่ต้องการ',
        step3Title: 'ดาวน์โหลดวิดีโอของคุณ',
        step3Description:
            'คลิก "Create" เพื่อดาวน์โหลดหรือแชร์วิดีโอที่สร้างขึ้นได้อย่างอิสระ',

        // YouTube videos section
        youtubeTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดล Runway Gen-4',
        youtubeVideosTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดล Runway Gen-4',
        youtubeVideoTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดล Runway Gen-4',

        // X Posts section
        xPostsTitle: 'โพสต์ X ยอดนิยมเกี่ยวกับโมเดล Runway Gen-4',

        // Explore other models section
        exploreModelsTitle: 'สำรวจโมเดลอื่นๆ',
        sora2Title: 'OpenAI Sora-2 ตัวสร้างวิดีโอ AI',
        veo3Title: 'Google Veo 3.1 ตัวสร้างวิดีโอ AI',
        wanAITitle: 'Wan AI ตัวสร้างวิดีโอ',
        klingTitle: 'kling 2.5 ตัวสร้างวิดีโอ',

        // FAQ section
        faqTitle: 'คำถามที่พบบ่อย',
        faq1Question: 'Runway AI คืออะไร?',
        faq1Answer:
            'Runway AI เป็นแพลตฟอร์มสร้างวิดีโอ AI ชั้นนำ ที่มีเครื่องมือสร้างวิดีโอหลากหลาย เช่น ข้อความเป็นวิดีโอ ภาพเป็นวิดีโอ และการตัดต่อวิดีโออัจฉริยะ ช่วยให้ครีเอเตอร์สร้างคอนเทนต์ระดับมืออาชีพได้ง่าย.',
        faq2Question: 'ฟีเจอร์หลักของ Runway AI มีอะไรบ้าง?',
        faq2Answer:
            'ฟีเจอร์หลักของ Runway AI ได้แก่ ข้อความเป็นวิดีโอ ภาพเป็นวิดีโอ การตัดต่อวิดีโออัจฉริยะ และชุดเครื่องมือสร้างสรรค์ สามารถสร้างวิดีโอจากคำอธิบาย แปลงภาพนิ่งเป็นวิดีโอ และให้ความสามารถตัดต่อที่ทรงพลัง.',
        faq3Question: 'ใช้ Runway AI ฟรีได้ไหม?',
        faq3Answer:
            'ได้ Runway AI ใช้งานได้ผ่านการทดลองฟรีของ 微鲤AI พร้อมเครดิตฟรีจำกัด หากใช้งานหนักต้องอัปเกรด.',
        faq4Question: 'Runway AI รองรับไฟล์วิดีโออะไรบ้าง?',
        faq4Answer:
            'Runway AI รองรับฟอร์แมตหลักหลายประเภท เช่น MP4, MOV, AVI เป็นต้น วิดีโอที่สร้างมีคุณภาพสูง เหมาะทั้งการแชร์บนโซเชียลและงานโปรดักชันวิดีโอระดับมืออาชีพ.',
        faq5Question:
            'ใช้ Runway AI กับงานมืออาชีพหรือเชิงพาณิชย์ได้ไหม?',
        faq5Answer:
            'ได้ การสร้างวิดีโอคุณภาพสูงและฟีเจอร์ตัดต่อที่ทรงพลัง ทำให้ Runway AI เป็นตัวเลือกที่ดีสำหรับโปรดิวเซอร์ ครีเอเตอร์ และผู้ใช้เชิงธุรกิจ.',

        // CTA section
        ctaTitle: 'พร้อมเริ่มสร้างแล้วหรือยัง?',
        ctaSubtitle:
            'ลองใช้ Runway ตอนนี้และเปลี่ยนความคิดสร้างสรรค์ของคุณให้เป็นวิดีโอสุดพิเศษ',
        ctaDescription:
            'ลองใช้ Runway ตอนนี้และเปลี่ยนความคิดสร้างสรรค์ของคุณให้เป็นวิดีโอสุดพิเศษ',
        ctaButton: 'เริ่มสร้างสรรค์',
        ctaNote: 'ไม่ต้องใช้บัตรเครดิต',
        ctaDisclaimer: 'ไม่ต้องใช้บัตรเครดิต · ทดลองใช้ฟรีสำหรับผู้ใช้ใหม่',

        // Runway Gen-4.5
        runway45Title: 'Runway Gen-4.5',
        runway45Desc:
            'ความคมชัดของภาพและการควบคุมเชิงสร้างสรรค์ที่ไม่เคยมีมาก่อน ให้ความรู้สึกภาพยนตร์และสมจริงสูง',

        // Video playback related
        videoNotSupported: 'เบราว์เซอร์ของคุณไม่รองรับการเล่นวิดีโอ',
        videoUnsupported: 'เบราว์เซอร์ของคุณไม่รองรับการเล่นวิดีโอ',
        videoLoadingError: 'โหลดวิดีโอล้มเหลว',
        videoLoadError: 'โหลดวิดีโอไม่สำเร็จ',
        videoReload: 'โหลดใหม่',
        },
    da: {
        // Page title and description
        pageTitle:
            'Runway Gen-4 videogenerator - professionelt videokreationsværktøj',
        pageDescription:
            'Oplev Runway Gen-4 videogenerator med text-to-video, image-to-video og intelligent videoredigering. Skab professionelle AI-videoer gratis på 微鲤AI.',
        pageKeywords:
            'Runway Gen-4, Runway AI, AI videogenerator, text to video, image to video, videoredigering, gratis AI video, 微鲤AI, videoproduktion',

        // Generator section
        generatorTitle: 'Runway Gen-4 videogenerator',
        generatorDescription:
            'Runway Gen-4 og Gen-4 Turbo er Runways nyeste <span >AI-videogenereringsmodeller</span>. Bygget på den tidligere Gen-3 Alpha Turbo-model forbedrer denne version markant <span >prompt-efterlevelse og bevægelsesrealisme</span> samt <span >konsistens af karakterer, stil og objekter</span> på tværs af scener. Oplev Runway Gen-4 Turbo nu på <span >微鲤AI vide-generatoren</span>!',

        // Tabs
        tabImageToVideo: 'Billede til video',
        tabTextToVideo: 'Tekst til video',

        // Core features section
        coreFeaturesTitle: 'Runway Gen-4 hovedfunktioner',
        coreFeaturesSubtitle:
            'Udforsk kernefunktionerne i Runway Gen-4 AI-videogeneratoren og begynd en revolutionerende AI-videorejse',

        // Realistic video generation
        realisticVideoTitle: 'Realistisk videogenerering',
        realisticVideoDescription:
            'Brug enkle referencebilleder til at generere realistiske og detaljerige videoer.',

        // Deeper prompt understanding
        deeperPromptTitle: 'Dybere promptforståelse',
        deeperPromptDescription:
            'Følger komplekse og detaljerede prompter med fejlfri præcision.',

        // Improved visual consistency
        visualConsistencyTitle: 'Forbedret visuel konsistens',
        visualConsistencyDescription:
            'Bevarer konsistens i karakterer, objekter og stilarter for at simulere realverdensfysik i ethvert miljø.',

        // Enhanced camera control
        cameraControlTitle: 'Forbedret kamerakontrol',
        cameraControlDescription:
            'Gør det lettere at styre flere motivbevægelser og kameravinkler i en scene.',

        // Faster video creation
        fasterVideoTitle: 'Hurtigere videoproduktion',
        fasterVideoDescription:
            'Med Gen-4 Turbo-modellen øges genereringshastigheden med 30 sekunder for hver 10 sekunders video.',

        // How to use section
        howToUseTitle: 'Sådan bruges',
        howToUseSubtitle: 'Tre enkle trin til at komme i gang',
        step1Title: 'Vælg Runway-model',
        step1Description:
            'Gå til <span >"AI Video Generation"</span>-siden og klik derefter på "Runway" i model-dropdownen.',
        step2Title: 'Indtast dit kreative indhold',
        step2Description:
            'Beskriv hvad du vil generere, eller upload billeder til konvertering, og vælg din foretrukne videokonfiguration.',
        step3Title: 'Download din video',
        step3Description:
            'Klik "Create" for frit at downloade eller dele din genererede video.',

        // YouTube videos section
        youtubeTitle: 'YouTube-videoer om Runway Gen-4-modellen',
        youtubeVideosTitle: 'YouTube-videoer om Runway Gen-4-modellen',
        youtubeVideoTitle: 'YouTube-videoer om Runway Gen-4-modellen',

        // X Posts section
        xPostsTitle: 'Populære X-opslag om Runway Gen-4-modellen',

        // Explore other models section
        exploreModelsTitle: 'Udforsk andre modeller',
        sora2Title: 'OpenAI Sora-2 AI-videogenerator',
        veo3Title: 'Google Veo 3.1 AI-videogenerator',
        wanAITitle: 'Wan AI-videogenerator',
        klingTitle: 'kling 2.5 videogenerator',

        // FAQ section
        faqTitle: 'Ofte stillede spørgsmål',
        faq1Question: 'Hvad er Runway AI?',
        faq1Answer:
            'Runway AI er en førende AI-videogenereringsplatform med kraftfulde værktøjer som text-to-video, image-to-video og intelligent videoredigering, så skabere let kan producere professionelt videoindhold.',
        faq2Question: 'Hvad er de vigtigste funktioner i Runway AI?',
        faq2Answer:
            'Runway AI\'s hovedfunktioner omfatter text-to-video, image-to-video, intelligent videoredigering og kreative værktøjspakker. Den kan generere videoer ud fra tekstbeskrivelser, konvertere stillbilleder til dynamiske videoer og give stærke videoredigeringsmuligheder.',
        faq3Question: 'Kan jeg bruge Runway AI gratis?',
        faq3Answer:
            'Ja. Runway AI er tilgængelig via 微鲤AI\'s gratis prøveperiode med begrænsede credits. Ved tung brug kræves opgradering.',
        faq4Question: 'Hvilke videoformater understøtter Runway AI?',
        faq4Answer:
            'Runway AI understøtter flere mainstream videoformater inkl. MP4, MOV, AVI m.fl. Genererede videoer er i høj kvalitet og egner sig til alt fra deling på sociale medier til professionel videoproduktion.',
        faq5Question:
            'Kan jeg bruge Runway AI til professionelle eller kommercielle projekter?',
        faq5Answer:
            'Ja. Runway AI\'s høje videokvalitet og kraftige redigeringsfunktioner gør den til et stærkt valg for professionelle videoproducenter, content creators og kommercielle brugere.',

        // CTA section
        ctaTitle: 'Klar til at begynde at skabe?',
        ctaSubtitle:
            'Oplev Runway nu og forvandl din kreativitet til fantastiske videoer',
        ctaDescription:
            'Oplev Runway nu og forvandl din kreativitet til fantastiske videoer',
        ctaButton: 'Begynd at skabe',
        ctaNote: 'Intet kreditkort kræves',
        ctaDisclaimer: 'Intet kreditkort kræves · Gratis prøveperiode for nye brugere',

        // Runway Gen-4.5
        runway45Title: 'Runway Gen-4.5',
        runway45Desc:
            'Uovertruffen visuel skarphed og kreativ kontrol, filmisk og ekstremt realistisk',

        // Video playback related
        videoNotSupported: 'Din browser understøtter ikke videoafspilning',
        videoUnsupported: 'Din browser understøtter ikke videoafspilning',
        videoLoadingError: 'Indlæsning af video mislykkedes',
        videoLoadError: 'Videoen kunne ikke indlæses',
        videoReload: 'Genindlæs',
        },
    no: {
        // Page title and description
        pageTitle:
            'Runway Gen-4 videogenerator - profesjonelt videokreasjonsverktøy',
        pageDescription:
            'Opplev Runway Gen-4 videogenerator med text-to-video, image-to-video og smart videoredigering. Lag profesjonelle AI-videoer gratis på 微鲤AI.',
        pageKeywords:
            'Runway Gen-4, Runway AI, AI videogenerator, text to video, image to video, videoredigering, gratis AI video, 微鲤AI, videoproduksjon',

        // Generator section
        generatorTitle: 'Runway Gen-4 videogenerator',
        generatorDescription:
            'Runway Gen-4 og Gen-4 Turbo er Runways nyeste <span >AI-videogenereringsmodeller</span>. Basert på den tidligere Gen-3 Alpha Turbo-modellen forbedrer denne versjonen betydelig <span >prompt-etterlevelse og bevegelsesrealisme</span>, samt <span >konsistens i karakterer, stil og objekter</span> på tvers av scener. Opplev Runway Gen-4 Turbo nå på <span >微鲤AI video generator</span>!',

        // Tabs
        tabImageToVideo: 'Bilde til video',
        tabTextToVideo: 'Tekst til video',

        // Core features section
        coreFeaturesTitle: 'Runway Gen-4 hovedfunksjoner',
        coreFeaturesSubtitle:
            'Utforsk kjernefunksjonene i Runway Gen-4 AI-videogeneratoren og start en revolusjonerende AI-videoreise',

        // Realistic video generation
        realisticVideoTitle: 'Realistisk videogenerering',
        realisticVideoDescription:
            'Bruk enkle referansebilder for å generere realistiske og detaljerike videoer.',

        // Deeper prompt understanding
        deeperPromptTitle: 'Dypere promptforståelse',
        deeperPromptDescription:
            'Følger komplekse og detaljerte prompter med feilfri presisjon.',

        // Improved visual consistency
        visualConsistencyTitle: 'Forbedret visuell konsistens',
        visualConsistencyDescription:
            'Bevarer konsistens i karakterer, objekter og stiler for å simulere virkelighetsfysikk i alle miljøer.',

        // Enhanced camera control
        cameraControlTitle: 'Forbedret kamerakontroll',
        cameraControlDescription:
            'Gjør det enklere å manipulere flere objekters bevegelser og kameravinkler i en scene.',

        // Faster video creation
        fasterVideoTitle: 'Raskere videoproduksjon',
        fasterVideoDescription:
            'Med Gen-4 Turbo-modellen økes genereringshastigheten med 30 sekunder for hver 10 sekunders video.',

        // How to use section
        howToUseTitle: 'Slik bruker du',
        howToUseSubtitle: 'Tre enkle trinn for å komme i gang',
        step1Title: 'Velg Runway-modell',
        step1Description:
            'Gå til <span >"AI Video Generation"</span>-siden og klikk "Runway" i modellnedtrekket.',
        step2Title: 'Skriv inn ditt kreative innhold',
        step2Description:
            'Beskriv hva du vil generere, eller last opp bilder for konvertering, og velg ønsket videokonfigurasjon.',
        step3Title: 'Last ned videoen din',
        step3Description:
            'Klikk "Create" for å laste ned eller dele den genererte videoen.',

        // YouTube videos section
        youtubeTitle: 'YouTube-videoer om Runway Gen-4-modellen',
        youtubeVideosTitle: 'YouTube-videoer om Runway Gen-4-modellen',
        youtubeVideoTitle: 'YouTube-videoer om Runway Gen-4-modellen',

        // X Posts section
        xPostsTitle: 'Populære X-innlegg om Runway Gen-4-modellen',

        // Explore other models section
        exploreModelsTitle: 'Utforsk andre modeller',
        sora2Title: 'OpenAI Sora-2 AI-videogenerator',
        veo3Title: 'Google Veo 3.1 AI-videogenerator',
        wanAITitle: 'Wan AI-videogenerator',
        klingTitle: 'kling 2.5 videogenerator',

        // FAQ section
        faqTitle: 'Ofte stilte spørsmål',
        faq1Question: 'Hva er Runway AI?',
        faq1Answer:
            'Runway AI er en ledende AI-videogenereringsplattform som tilbyr kraftige verktøy som text-to-video, image-to-video og intelligent videoredigering, slik at skapere enkelt kan produsere profesjonelt videoinnhold.',
        faq2Question: 'Hva er hovedfunksjonene i Runway AI?',
        faq2Answer:
            'Runway AI sine hovedfunksjoner inkluderer text-to-video, image-to-video, intelligent videoredigering og kreative verktøypakker. Den kan generere videoer basert på tekstbeskrivelser, konvertere stillbilder til dynamiske videoer og gi kraftige redigeringsmuligheter.',
        faq3Question: 'Kan jeg bruke Runway AI gratis?',
        faq3Answer:
            'Ja. Runway AI er tilgjengelig via 微鲤AI\'s gratis prøveperiode med begrensede credits. Ved tung bruk kreves oppgradering.',
        faq4Question: 'Hvilke videoformater støtter Runway AI?',
        faq4Answer:
            'Runway AI støtter flere vanlige videoformater som MP4, MOV, AVI osv. Genererte videoer er av høy kvalitet og egnet til alt fra deling på sosiale medier til profesjonell videoproduksjon.',
        faq5Question:
            'Kan jeg bruke Runway AI til profesjonelle eller kommersielle prosjekter?',
        faq5Answer:
            'Ja. Runway AI sin høye videokvalitet og kraftige redigeringsfunksjoner gjør den til et godt valg for profesjonelle videoprodusenter, content creators og kommersielle brukere.',

        // CTA section
        ctaTitle: 'Klar til å begynne å skape?',
        ctaSubtitle:
            'Opplev Runway nå og gjør kreativiteten din om til fantastiske videoer',
        ctaDescription:
            'Opplev Runway nå og gjør kreativiteten din om til fantastiske videoer',
        ctaButton: 'Begynn å skape',
        ctaNote: 'Ingen kredittkort kreves',
        ctaDisclaimer: 'Ingen kredittkort kreves · Gratis prøveperiode for nye brukere',

        // Runway Gen-4.5
        runway45Title: 'Runway Gen-4.5',
        runway45Desc:
            'Enestående visuell presisjon og kreativ kontroll, filmatisk og svært realistisk',

        // Video playback related
        videoNotSupported: 'Nettleseren din støtter ikke videoavspilling',
        videoUnsupported: 'Nettleseren din støtter ikke videoavspilling',
        videoLoadingError: 'Videoen kunne ikke lastes',
        videoLoadError: 'Videoen kunne ikke lastes inn',
        videoReload: 'Last inn på nytt',
        },
    nl: {
        // Page title and description
        pageTitle:
            'Runway Gen-4 videogenerator - professionele videoproductietool',
        pageDescription:
            'Ervaar de Runway Gen-4 videogenerator met text-to-video, image-to-video en slimme videobewerking. Maak gratis professionele AI-video\'s op 微鲤AI.',
        pageKeywords:
            'Runway Gen-4, Runway AI, AI videogenerator, text to video, image to video, videobewerking, gratis AI video, 微鲤AI, videoproductie',

        // Generator section
        generatorTitle: 'Runway Gen-4 videogenerator',
        generatorDescription:
            'Runway Gen-4 en Gen-4 Turbo zijn Runway\'s nieuwste <span >AI-videogeneratiemodellen</span>. Voortbouwend op de vorige Gen-3 Alpha Turbo verbetert deze versie aanzienlijk <span >prompt-naleving en bewegingsrealisme</span> en <span >consistentie van personages, stijl en objecten</span> tussen scènes. Ervaar Runway Gen-4 Turbo nu op de <span >微鲤AI videgenerator</span>!',

        // Tabs
        tabImageToVideo: 'Afbeelding naar video',
        tabTextToVideo: 'Tekst naar video',

        // Core features section
        coreFeaturesTitle: 'Belangrijkste functies van Runway Gen-4',
        coreFeaturesSubtitle:
            'Ontdek de kernfuncties van de Runway Gen-4 AI-videogenerator en begin aan een revolutionaire AI-videoreis',

        // Realistic video generation
        realisticVideoTitle: 'Realistische videogeneratie',
        realisticVideoDescription:
            'Gebruik eenvoudige referentiebeelden om realistische en detailrijke video\'s te genereren.',

        // Deeper prompt understanding
        deeperPromptTitle: 'Dieper promptbegrip',
        deeperPromptDescription:
            'Volgt complexe en gedetailleerde prompts met onberispelijke nauwkeurigheid.',

        // Improved visual consistency
        visualConsistencyTitle: 'Verbeterde visuele consistentie',
        visualConsistencyDescription:
            'Behoudt consistentie van personages, objecten en stijlen om echte fysica te simuleren in elke omgeving.',

        // Enhanced camera control
        cameraControlTitle: 'Verbeterde camerabesturing',
        cameraControlDescription:
            'Manipuleer eenvoudiger meerdere onderwerpbewegingen en cameraperspectieven in een scène.',

        // Faster video creation
        fasterVideoTitle: 'Snellere videoproductie',
        fasterVideoDescription:
            'Met het Gen-4 Turbo-model neemt de generatiesnelheid toe met 30 seconden per 10 seconden video.',

        // How to use section
        howToUseTitle: 'Hoe te gebruiken',
        howToUseSubtitle: 'Drie eenvoudige stappen om te beginnen',
        step1Title: 'Selecteer het Runway-model',
        step1Description:
            'Ga naar de <span >"AI Video Generation"</span>-pagina en klik vervolgens op "Runway" in het modeldropdownmenu.',
        step2Title: 'Voer je creatieve content in',
        step2Description:
            'Beschrijf wat je wilt genereren, of upload beelden voor conversie en kies je gewenste videoconfiguratie.',
        step3Title: 'Download je video',
        step3Description:
            'Klik op "Create" om je gegenereerde video vrij te downloaden of te delen.',

        // YouTube videos section
        youtubeTitle: 'YouTube-video\'s over het Runway Gen-4-model',
        youtubeVideosTitle: 'YouTube-video\'s over het Runway Gen-4-model',
        youtubeVideoTitle: 'YouTube-video\'s over het Runway Gen-4-model',

        // X Posts section
        xPostsTitle: 'Populaire X-berichten over het Runway Gen-4-model',

        // Explore other models section
        exploreModelsTitle: 'Ontdek andere modellen',
        sora2Title: 'OpenAI Sora-2 AI-videogenerator',
        veo3Title: 'Google Veo 3.1 AI-videogenerator',
        wanAITitle: 'Wan AI-videogenerator',
        klingTitle: 'kling 2.5 videogenerator',

        // FAQ section
        faqTitle: 'Veelgestelde vragen',
        faq1Question: 'Wat is Runway AI?',
        faq1Answer:
            'Runway AI is een toonaangevend AI-videogeneratieplatform met krachtige tools zoals text-to-video, image-to-video en intelligente videobewerking, waarmee makers eenvoudig professioneel videomateriaal kunnen produceren.',
        faq2Question: 'Wat zijn de belangrijkste functies van Runway AI?',
        faq2Answer:
            'De belangrijkste functies zijn text-to-video, image-to-video, intelligente videobewerking en creatieve toolsets. Het kan video\'s genereren op basis van tekst, stille beelden omzetten naar dynamische video\'s en krachtige bewerkingsmogelijkheden bieden.',
        faq3Question: 'Kan ik Runway AI gratis gebruiken?',
        faq3Answer:
            'Ja. Runway AI is beschikbaar via de gratis proefperiode van 微鲤AI met beperkte credits. Voor intensief gebruik is een upgrade vereist.',
        faq4Question: 'Welke videoformaten ondersteunt Runway AI?',
        faq4Answer:
            'Runway AI ondersteunt meerdere gangbare videoformaten zoals MP4, MOV, AVI, enz. De gegenereerde video\'s zijn van hoge kwaliteit en geschikt voor alles van social media tot professionele videoproductie.',
        faq5Question:
            'Kan ik Runway AI gebruiken voor professionele of commerciële projecten?',
        faq5Answer:
            'Ja. De hoge videokwaliteit en krachtige bewerkingsfuncties maken Runway AI een sterke keuze voor professionele videomakers, content creators en zakelijke gebruikers.',

        // CTA section
        ctaTitle: 'Klaar om te beginnen?',
        ctaSubtitle:
            'Ervaar Runway nu en transformeer je creativiteit in geweldige video\'s',
        ctaDescription:
            'Ervaar Runway nu en transformeer je creativiteit in geweldige video\'s',
        ctaButton: 'Begin met creëren',
        ctaNote: 'Geen creditcard nodig',
        ctaDisclaimer: 'Geen creditcard nodig · Gratis proefperiode voor nieuwe gebruikers',

        // Runway Gen-4.5
        runway45Title: 'Runway Gen-4.5',
        runway45Desc:
            'Ongekende visuele scherpte en creatieve controle, filmisch en zeer realistisch',

        // Video playback related
        videoNotSupported: 'Je browser ondersteunt geen video-afspelen',
        videoUnsupported: 'Je browser ondersteunt geen video-afspelen',
        videoLoadingError: 'Videoladen mislukt',
        videoLoadError: 'Video kon niet worden geladen',
        videoReload: 'Herladen',
        },
    id: {
        // Page title and description
        pageTitle:
            'Generator Video Runway Gen-4 - Alat Pembuatan Video Profesional',
        pageDescription:
            'Rasakan Runway Gen-4 video generator dengan text-to-video, image-to-video, dan kemampuan editing video cerdas. Buat video AI profesional gratis di 微鲤AI.',
        pageKeywords:
            'Runway Gen-4, Runway AI, generator video AI, text to video, image to video, editing video, video AI gratis, 微鲤AI, produksi video',

        // Generator section
        generatorTitle: 'Generator Video AI Runway Gen-4',
        generatorDescription:
            'Runway Gen-4 dan Gen-4 Turbo adalah <span >model generasi video AI terbaru Runway</span>. Berdasarkan Gen-3 Alpha Turbo sebelumnya, versi baru ini meningkatkan secara signifikan <span >kepatuhan prompt dan realisme gerak</span>, serta <span >konsistensi karakter, gaya, dan objek</span> antar adegan. Rasakan Runway Gen-4 Turbo sekarang di <span >generator video 微鲤AI</span>!',

        // Tabs
        tabImageToVideo: 'Gambar ke Video',
        tabTextToVideo: 'Teks ke Video',

        // Core features section
        coreFeaturesTitle: 'Fitur Utama Runway Gen-4',
        coreFeaturesSubtitle:
            'Jelajahi fitur inti generator video AI Runway Gen-4 dan mulai perjalanan kreasi video AI yang revolusioner',

        // Realistic video generation
        realisticVideoTitle: 'Generasi Video Realistis',
        realisticVideoDescription:
            'Gunakan gambar referensi sederhana untuk menghasilkan video yang realistis dan kaya detail.',

        // Deeper prompt understanding
        deeperPromptTitle: 'Pemahaman Prompt Lebih Dalam',
        deeperPromptDescription:
            'Mengikuti prompt yang kompleks dan detail dengan akurasi tinggi.',

        // Improved visual consistency
        visualConsistencyTitle: 'Konsistensi Visual yang Lebih Baik',
        visualConsistencyDescription:
            'Menjaga konsistensi karakter, objek, dan gaya untuk mensimulasikan fisika dunia nyata di berbagai lingkungan.',

        // Enhanced camera control
        cameraControlTitle: 'Kontrol Kamera yang Ditingkatkan',
        cameraControlDescription:
            'Lebih mudah mengatur pergerakan banyak subjek dan perspektif kamera dalam satu adegan.',

        // Faster video creation
        fasterVideoTitle: 'Pembuatan Video Lebih Cepat',
        fasterVideoDescription:
            'Dengan model Gen-4 Turbo, kecepatan generasi meningkat 30 detik untuk setiap 10 detik video.',

        // How to use section
        howToUseTitle: 'Cara Menggunakan',
        howToUseSubtitle: 'Tiga langkah sederhana untuk memulai',
        step1Title: 'Pilih Model Runway',
        step1Description:
            'Buka halaman <span >"AI Video Generation"</span>, lalu klik "Runway" di menu dropdown model.',
        step2Title: 'Masukkan Konten Kreatif Anda',
        step2Description:
            'Jelaskan apa yang ingin dibuat, atau unggah gambar untuk konversi, dan pilih konfigurasi video yang diinginkan.',
        step3Title: 'Unduh Video Anda',
        step3Description:
            'Klik "Create" untuk mengunduh atau membagikan video yang dihasilkan.',

        // YouTube videos section
        youtubeTitle: 'Video YouTube tentang Model Runway Gen-4',
        youtubeVideosTitle: 'Video YouTube tentang Model Runway Gen-4',
        youtubeVideoTitle: 'Video YouTube tentang Model Runway Gen-4',

        // X Posts section
        xPostsTitle: 'Posting X Populer tentang Model Runway Gen-4',

        // Explore other models section
        exploreModelsTitle: 'Jelajahi Model Lain',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        veo3Title: 'Google Veo 3.1 AI Video Generator',
        wanAITitle: 'Wan AI Video Generator',
        klingTitle: 'kling 2.5 Video Generator',

        // FAQ section
        faqTitle: 'Pertanyaan yang Sering Diajukan',
        faq1Question: 'Apa itu Runway AI?',
        faq1Answer:
            'Runway AI adalah platform generasi video AI terkemuka yang menyediakan berbagai alat pembuatan video kuat seperti text-to-video, image-to-video, dan editing video cerdas, memungkinkan kreator menghasilkan konten video level profesional dengan mudah.',
        faq2Question: 'Apa fitur utama Runway AI?',
        faq2Answer:
            'Fitur utama Runway AI mencakup: text-to-video, image-to-video, editing video cerdas, serta suite alat kreatif. Runway dapat menghasilkan video dari deskripsi teks, mengubah gambar statis menjadi video dinamis, dan menyediakan kemampuan editing video yang kuat.',
        faq3Question: 'Apakah saya bisa menggunakan Runway AI gratis?',
        faq3Answer:
            'Ya. Runway AI tersedia melalui uji coba gratis 微鲤AI dengan kredit gratis terbatas. Untuk penggunaan berat, diperlukan upgrade.',
        faq4Question: 'Format video apa yang didukung Runway AI?',
        faq4Answer:
            'Runway AI mendukung berbagai format video populer termasuk MP4, MOV, AVI, dll. Video yang dihasilkan berkualitas tinggi, cocok untuk berbagai kebutuhan dari berbagi di media sosial hingga produksi video profesional.',
        faq5Question:
            'Bisakah saya menggunakan Runway AI untuk proyek profesional atau komersial?',
        faq5Answer:
            'Ya. Kualitas generasi video yang tinggi dan fitur editing yang kuat menjadikan Runway AI pilihan tepat bagi produser video profesional, content creator, dan pengguna komersial.',

        // CTA section
        ctaTitle: 'Siap Mulai Berkarya?',
        ctaSubtitle:
            'Coba Runway sekarang dan ubah kreativitas Anda menjadi video menakjubkan',
        ctaDescription:
            'Coba Runway sekarang dan ubah kreativitas Anda menjadi video menakjubkan',
        ctaButton: 'Mulai Berkarya',
        ctaNote: 'Tanpa kartu kredit',
        ctaDisclaimer: 'Tanpa kartu kredit · Uji coba gratis untuk pengguna baru',

        // Runway Gen-4.5
        runway45Title: 'Runway Gen-4.5',
        runway45Desc:
            'Ketajaman visual dan kontrol kreatif yang belum pernah ada, sinematik dan sangat realistis',

        // Video playback related
        videoNotSupported: 'Browser Anda tidak mendukung pemutaran video',
        videoUnsupported: 'Browser Anda tidak mendukung pemutaran video',
        videoLoadingError: 'Pemuatan video gagal',
        videoLoadError: 'Video gagal dimuat',
        videoReload: 'Muat ulang',
        },
    tr: {
        // Page title and description
        pageTitle:
            'Runway Gen-4 Video Üretici - Profesyonel Video Üretim Aracı',
        pageDescription:
            'Runway Gen-4 video generator ile metinden videoya, görüntüden videoya ve akıllı video düzenleme özelliklerini deneyimleyin. 微鲤AI’de ücretsiz profesyonel AI videolar üretin.',
        pageKeywords:
            'Runway Gen-4, Runway AI, AI video generator, text to video, image to video, video editing, free AI video, 微鲤AI, video production',

        // Generator section
        generatorTitle: 'Runway Gen-4 Video Üretici',
        generatorDescription:
            'Runway Gen-4 ve Gen-4 Turbo, Runway\'in en yeni <span >AI video üretim modelleridir</span>. Önceki Gen-3 Alpha Turbo modelinin üzerine inşa edilen bu sürüm, <span >istem uyumu ve hareket gerçekçiliğini</span> ve <span >karakter, stil ve nesne tutarlılığını</span> sahneler arasında önemli ölçüde geliştirir. Runway Gen-4 Turbo\'yu şimdi <span >微鲤AI video üreticisinde</span> deneyimleyin!',

        // Tabs
        tabImageToVideo: 'Görüntüden Videoya',
        tabTextToVideo: 'Metinden Videoya',

        // Core features section
        coreFeaturesTitle: 'Runway Gen-4 Temel Özellikleri',
        coreFeaturesSubtitle:
            'Runway Gen-4 AI video üreticisinin temel özelliklerini keşfedin ve devrim niteliğinde bir AI video üretim yolculuğuna çıkın',

        // Realistic video generation
        realisticVideoTitle: 'Gerçekçi Video Üretimi',
        realisticVideoDescription:
            'Basit referans görselleri kullanarak gerçekçi ve detaylı videolar üretin.',

        // Deeper prompt understanding
        deeperPromptTitle: 'Daha Derin İstem Anlayışı',
        deeperPromptDescription:
            'Karmaşık ve ayrıntılı istemleri kusursuz doğrulukla takip eder.',

        // Improved visual consistency
        visualConsistencyTitle: 'Geliştirilmiş Görsel Tutarlılık',
        visualConsistencyDescription:
            'Gerçek dünyadaki fiziği simüle etmek için karakter, nesne ve stil tutarlılığını her ortamda korur.',

        // Enhanced camera control
        cameraControlTitle: 'Geliştirilmiş Kamera Kontrolü',
        cameraControlDescription:
            'Bir sahnede birden fazla öznenin hareketini ve kamera perspektifini daha kolay yönetin.',

        // Faster video creation
        fasterVideoTitle: 'Daha Hızlı Video Üretimi',
        fasterVideoDescription:
            'Gen-4 Turbo modeliyle üretim hızı her 10 saniyelik video için 30 saniye artar.',

        // How to use section
        howToUseTitle: 'Nasıl Kullanılır',
        howToUseSubtitle: 'Başlamak için üç basit adım',
        step1Title: 'Runway Modelini Seçin',
        step1Description:
            '<span >"AI Video Generation"</span> sayfasına gidin ve model açılır menüsünden "Runway"i seçin.',
        step2Title: 'Yaratıcı İçeriğinizi Girin',
        step2Description:
            'Oluşturmak istediğinizi açıklayın veya dönüştürmek için görseller yükleyin ve tercih ettiğiniz video yapılandırmasını seçin.',
        step3Title: 'Videonuzu İndirin',
        step3Description:
            'Oluşturulan videoyu indirmek veya paylaşmak için "Create"e tıklayın.',

        // YouTube videos section
        youtubeTitle: 'Runway Gen-4 Modeli Hakkında YouTube Videoları',
        youtubeVideosTitle: 'Runway Gen-4 Modeli Hakkında YouTube Videoları',
        youtubeVideoTitle: 'Runway Gen-4 Modeli Hakkında YouTube Videoları',

        // X Posts section
        xPostsTitle: 'Runway Gen-4 Modeli Hakkında Popüler X Paylaşımları',

        // Explore other models section
        exploreModelsTitle: 'Diğer Modelleri Keşfedin',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        veo3Title: 'Google Veo 3.1 AI Video Generator',
        wanAITitle: 'Wan AI Video Generator',
        klingTitle: 'kling 2.5 Video Generator',

        // FAQ section
        faqTitle: 'Sık Sorulan Sorular',
        faq1Question: 'Runway AI nedir?',
        faq1Answer:
            'Runway AI; metinden videoya, görüntüden videoya ve akıllı video düzenleme gibi güçlü araçlar sunan, yaratıcıların profesyonel seviyede video içerikleri kolayca üretmesini sağlayan lider bir AI video üretim platformudur.',
        faq2Question: 'Runway AI’nin temel özellikleri nelerdir?',
        faq2Answer:
            'Runway AI’nin temel özellikleri: metinden videoya, görüntüden videoya, akıllı video düzenleme ve yaratıcı araç paketleridir. Metin açıklamalarına göre video üretir, statik görüntüleri dinamik videolara dönüştürür ve güçlü düzenleme yetenekleri sunar.',
        faq3Question: 'Runway AI’yi ücretsiz kullanabilir miyim?',
        faq3Answer:
            'Evet. Runway AI, sınırlı ücretsiz krediyle 微鲤AI’nin ücretsiz denemesi üzerinden kullanılabilir. Yoğun kullanım için yükseltme gerekir.',
        faq4Question: 'Runway AI hangi video formatlarını destekler?',
        faq4Answer:
            'Runway AI, MP4, MOV, AVI vb. dahil birçok yaygın video formatını destekler. Üretilen videolar yüksek kalitededir ve sosyal medya paylaşımından profesyonel video prodüksiyonuna kadar birçok amaç için uygundur.',
        faq5Question:
            'Runway AI’yi profesyonel veya ticari projelerde kullanabilir miyim?',
        faq5Answer:
            'Evet. Runway AI’nin yüksek kaliteli video üretimi ve güçlü düzenleme özellikleri, profesyonel video yapımcıları, içerik üreticileri ve ticari kullanıcılar için güçlü bir seçimdir.',

        // CTA section
        ctaTitle: 'Oluşturmaya Hazır mısınız?',
        ctaSubtitle:
            'Runway’i şimdi deneyin ve yaratıcılığınızı harika videolara dönüştürün',
        ctaDescription:
            'Runway’i şimdi deneyin ve yaratıcılığınızı harika videolara dönüştürün',
        ctaButton: 'Oluşturmaya Başla',
        ctaNote: 'Kredi kartı gerekmez',
        ctaDisclaimer: 'Kredi kartı gerekmez · Yeni kullanıcılar için ücretsiz deneme',

        // Runway Gen-4.5
        runway45Title: 'Runway Gen-4.5',
        runway45Desc:
            'Eşi görülmemiş görsel doğruluk ve yaratıcı kontrol; sinematik ve son derece gerçekçi',

        // Video playback related
        videoNotSupported: 'Tarayıcınız video oynatmayı desteklemiyor',
        videoUnsupported: 'Tarayıcınız video oynatmayı desteklemiyor',
        videoLoadingError: 'Video yüklenemedi',
        videoLoadError: 'Video yükleme başarısız',
        videoReload: 'Yeniden yükle',
        },
}
